import { createIcon } from "@chakra-ui/icons";

export const AdobexdLogo = createIcon({
  displayName: "AdobexdLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z"
        fill="#470137"
      />
      <path
        d="M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z"
        fill="#FF61F6"
      />
    </g>
  ),
});
export const AppleLogo = createIcon({
  displayName: "AppleLogo",
  viewBox: "0 0 15 18",
  path: (
    <g width="15" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#Apple_logo_black 1__a)">
        <path
          d="M12.507 17.28c-.966.947-2.031.8-3.046.353-1.08-.456-2.067-.484-3.207 0-1.42.619-2.173.439-3.029-.353C-1.602 12.258-.89 4.608 4.597 4.32c1.33.072 2.263.743 3.046.8 1.166-.24 2.28-.926 3.528-.836 1.498.122 2.619.72 3.367 1.795-3.082 1.872-2.352 5.976.479 7.128-.566 1.503-1.293 2.988-2.512 4.086l.002-.013ZM7.537 4.266C7.392 2.034 9.183.198 11.242.018c.283 2.574-2.316 4.5-3.705 4.248Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="Apple_logo_black 1__a">
          <path fill="currentColor" d="M0 0h15v18H0z" />
        </clipPath>
      </defs>
    </g>
  ),
});
export const AndroidLogo = createIcon({
  displayName: "AndroidLogo",
  viewBox: "0 0 16 18",
  path: (
    <g width="16" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.9.051a.571.571 0 0 0-.263.066.518.518 0 0 0-.214.715l.595 1.029C3.584 2.71 2.634 4.16 2.634 5.815v.307a1.525 1.525 0 0 0-1.132-.494C.672 5.628 0 6.27 0 7.064v4.426c0 .793.673 1.437 1.502 1.437.452 0 .857-.192 1.132-.495v.62c0 .836.715 1.52 1.588 1.52h.404v1.969c0 .793.672 1.436 1.501 1.436.829 0 1.502-.643 1.502-1.436v-1.97h.697v1.97c0 .793.673 1.436 1.502 1.436.828 0 1.501-.643 1.501-1.436v-1.97h.403c.874 0 1.588-.683 1.588-1.519v-.62c.276.303.68.495 1.133.495.829 0 1.502-.644 1.502-1.437V7.064c0-.793-.673-1.436-1.502-1.436-.452 0-.857.191-1.133.494v-.307c0-1.655-.952-3.104-2.385-3.953l.596-1.03a.518.518 0 0 0-.214-.715.571.571 0 0 0-.748.205L9.945 1.4a5.906 5.906 0 0 0-1.968-.333c-.692 0-1.357.117-1.967.332L5.386.322a.556.556 0 0 0-.487-.27Z"
        fill="#fffcurrentColor"
      />
      <path
        d="M1.501 6.002c-.618 0-1.11.47-1.11 1.062v4.426c0 .592.492 1.063 1.11 1.063.618 0 1.11-.471 1.11-1.063V7.064c0-.591-.492-1.062-1.11-1.062Zm12.952 0c-.619 0-1.11.47-1.11 1.062v4.426c0 .592.491 1.063 1.11 1.063.618 0 1.11-.471 1.11-1.063V7.064c0-.591-.492-1.062-1.11-1.062Zm-8.327 5.05c-.618 0-1.11.471-1.11 1.063v4.426c0 .591.492 1.062 1.11 1.062.618 0 1.11-.47 1.11-1.062v-4.426c0-.592-.492-1.063-1.11-1.063Zm3.7 0c-.618 0-1.11.471-1.11 1.063v4.426c0 .591.492 1.062 1.11 1.062.619 0 1.111-.47 1.111-1.062v-4.426c0-.592-.492-1.063-1.11-1.063Z"
        fill="currentColor"
      />
      <path
        d="M4.9.426a.16.16 0 0 0-.074.02.141.141 0 0 0-.061.204l.782 1.352c-1.505.75-2.522 2.174-2.524 3.808h9.905c-.003-1.634-1.02-3.058-2.524-3.808L11.186.65c.044-.076.018-.163-.061-.205a.16.16 0 0 0-.075-.02.157.157 0 0 0-.14.079l-.792 1.367a5.483 5.483 0 0 0-2.143-.43c-.767 0-1.494.154-2.142.43L5.04.504A.157.157 0 0 0 4.9.426ZM3.024 6.184v6.868c0 .635.534 1.146 1.198 1.146h7.51c.663 0 1.197-.511 1.197-1.146V6.184H3.023Z"
        fill="currentColor"
      />
      <path
        d="M5.69 3.285a.407.407 0 0 0-.413.395c0 .216.187.395.414.395a.407.407 0 0 0 .413-.395.407.407 0 0 0-.413-.395Zm4.572 0a.407.407 0 0 0-.414.395c0 .216.188.395.414.395a.407.407 0 0 0 .413-.395.407.407 0 0 0-.413-.395Z"
        fill="currentColor"
      />
    </g>
  ),
});
export const WindowsLogo = createIcon({
  displayName: "WindowsLogo",
  viewBox: "0 0 19 18",
  path: (
    <g width="19" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m0 2.537 7.705-.994.004 7.04-7.702.042L0 2.537Zm7.701 6.858.006 7.047L.006 15.44V9.348l7.695.047Zm.935-7.982L18.852 0v8.494l-10.216.077V1.413ZM18.854 9.46l-.002 8.456L8.636 16.55l-.015-7.106 10.233.016Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const AtlassianLogo = createIcon({
  displayName: "AtlassianLogo",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        d="M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z"
        fill="#2684FF"
      />
      <path
        d="M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z"
        fill="#2684FF"
      />
    </g>
  ),
});

export const CartIcon = createIcon({
  displayName: "CartIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z"
    />
  ),
});

export const ClockIcon = createIcon({
  displayName: "ClockIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g>
            <path
              fill="currentColor"
              d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});

export const CreditIcon = createIcon({
  displayName: "CreditIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z"
    />
  ),
});

export const DashboardLogo = createIcon({
  displayName: "DashboardLogo",
  viewBox: "0 0 1000 257",
  path: (
    <g width="998" height="257" viewBox="0 0 998 257" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z"
          fill="currentColor"
        />
        <path
          d="M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z"
          fill="currentColor"
        />
        <path
          d="M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z"
          fill="currentColor"
        />
        <path
          d="M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z"
          fill="currentColor"
        />
        <path
          d="M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z"
          fill="currentColor"
        />
        <path
          d="M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z"
          fill="currentColor"
        />
        <rect width="257" height="257" rx="128.5" fill="#4FD1C5" />
        <path
          d="M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="128.5"
          y1="0"
          x2="128.5"
          y2="257"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7BCBD4" />
          <stop offset="1" stop-color="#29C6B7" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="997.832" height="257" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
});

export const DashboardLogoWhite = createIcon({
  displayName: "DashboardLogo",
  viewBox: "0 0 163.5 42",
  path: (
    <g fill="none">
      <path
        d="M63.452 19.292c2.877 0 4.16 1.911 4.587 3.623l4.043-1.513c-.777-3.106-3.576-6.371-8.668-6.371-5.443 0-9.68 4.3-9.68 10.274 0 5.893 4.237 10.313 9.796 10.313 4.976 0 7.813-3.305 8.707-6.331l-3.965-1.473c-.427 1.473-1.788 3.583-4.742 3.583-2.837 0-5.286-2.19-5.286-6.092 0-3.903 2.449-6.013 5.208-6.013zM79.196 23.632c.078-2.469 1.438-4.38 3.926-4.38 2.838 0 3.887 1.911 3.887 4.3v11.47h4.51V22.755c0-4.26-2.255-7.685-6.92-7.685-1.982 0-4.12.716-5.403 2.429V6.19h-4.509v28.831h4.51V23.632zM94.287 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.936-1.592 5.83-3.066 0 1.553.156 2.35.195 2.47h4.198c-.039-.2-.233-1.355-.233-3.107v-9.637c0-3.862-2.216-7.247-8.047-7.247-4.664 0-7.619 2.986-7.968 6.332l4.12.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.226.478-5.714 2.39-5.714 5.854zm7.269 2.23c-1.788 0-2.76-1.195-2.76-2.509 0-1.593 1.127-2.39 2.527-2.628l4.936-.757v.876c0 3.783-2.176 5.018-4.703 5.018zM132.312 15.628h-5.986l-7.269 7.845V6.191h-4.47v28.83h4.47v-5.416l2.332-2.508 5.559 7.924h5.52l-7.93-11.19 7.774-8.203zM145.254 15.509a6.3 6.3 0 00-1.205-.12c-2.487 0-4.587 1.235-5.481 3.345v-3.106h-4.392v19.393h4.509v-9.238c0-3.624 1.594-5.695 5.092-5.695.467 0 .972.04 1.477.12v-4.7zM146.335 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.937-1.592 5.831-3.066 0 1.553.156 2.35.194 2.47h4.199c-.039-.2-.234-1.355-.234-3.107v-9.637c0-3.862-2.215-7.247-8.046-7.247-4.665 0-7.619 2.986-7.969 6.332l4.121.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.227.478-5.715 2.39-5.715 5.854zm7.269 2.23c-1.788 0-2.759-1.195-2.759-2.509 0-1.593 1.127-2.39 2.526-2.628l4.937-.757v.876c0 3.783-2.177 5.018-4.704 5.018zM41.975 21.5C41.975 9.626 32.578 0 20.987 0 9.398 0 0 9.626 0 21.5S9.396 43 20.988 43c11.59 0 20.987-9.626 20.987-21.5z"
        fill="#fff"
      />
      <path
        d="M11.36 22.418L25.668 7.863c.267-.272.697.06.517.398l-5.325 9.997c-.119.223.039.495.287.495h9.202c.296 0 .44.372.223.58L14.446 34.748c-.29.277-.72-.113-.488-.44l7.633-10.788c.157-.221.003-.531-.264-.531H11.59c-.292 0-.437-.362-.23-.572z"
        fill="#3BCBBE"
      />
    </g>
  ),
});

export const DocumentIcon = createIcon({
  displayName: "DocumentIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z"
      />
      <path
        fill="currentColor"
        d="M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z"
      />
    </g>
  ),
});

export const GlobeIcon = createIcon({
  displayName: "GlobeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z"
        strokeWidth=".75"
        stroke-miterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z"
        strokeWidth=".75"
        stroke-miterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904"
        strokeWidth=".75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109v18.28M20.39 11.249H2.11"
        strokeWidth=".75"
        stroke-miterlimit="10"
      />
    </g>
  ),
});

export const HelpIcon = createIcon({
  displayName: "HelpIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z"
    />
  ),
});

export const HomeIcon = createIcon({
  displayName: "HomeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z"
      />
      <path
        fill="currentColor"
        d="M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z"
      />
    </g>
  ),
});

export const InvisionLogo = createIcon({
  displayName: "InvisionLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z"
        fill="#DC395F"
      />
      <path
        d="M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74"
        fill="#fff"
      />
    </g>
  ),
});

export const JiraLogo = createIcon({
  displayName: "JiraLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z"
        fill="#2684FF"
      />
      <path
        d="M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z"
        fill="url(#paint1_linear)"
      />
    </g>
  ),
});

export const MastercardIcon = createIcon({
  displayName: "MastercardIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      width="24"
      height="20"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.63158" cy="7.49999" r="6.63158" fill="#EB001B" />
      <circle cx="14.3686" cy="7.49999" r="6.63158" fill="#F79E1B" />
    </svg>
  ),
});

export const PayPalIcon = createIcon({
  displayName: "PayPalIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z"
      />
      <path
        fill="currentColor"
        d="M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z"
      />
    </g>
  ),
});

export const PersonIcon = createIcon({
  displayName: "PersonIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z"
    />
  ),
});

export const ProfileIcon = createIcon({
  displayName: "ProfileIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path d="M0 0h24v24H0V0z" fill="transparent" />
      <path
        fill="currentColor"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
      />
    </g>
  ),
});

export const RocketIcon = createIcon({
  displayName: "RocketIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z"
      />
      <path
        fill="currentColor"
        d="M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z"
      />
    </g>
  ),
});

export const SettingsIcon = createIcon({
  displayName: "SettingsIcon",
  viewBox: "0 0 24 24",
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g>
      <path d="M0,0h24v24H0V0z" fill="none" />
      <path
        fill="currentColor"
        d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
      />
    </g>
  ),
});

export const SlackLogo = createIcon({
  displayName: "SlackLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)" fill-rule="evenodd" clip-rule="evenodd">
      <path
        d="M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z"
        fill="#36C5F0"
      />
      <path
        d="M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z"
        fill="#2EB67D"
      />
      <path
        d="M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z"
        fill="#ECB22E"
      />
      <path
        d="M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z"
        fill="#E01E5A"
      />
    </g>
  ),
});

export const SpotifyLogo = createIcon({
  displayName: "SpotifyLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z"
        fill="#2EBD59"
      />
    </g>
  ),
});

export const HorizonLogo = createIcon({
  displayName: "horizonLogo",
  viewBox: "0 0 179 20",
  path: (
    <g width="179" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.42.748V19h-4.446v-7.514H5.058V19H.612V.748h4.446v7.15h6.916V.748h4.446Zm11.842 18.434c-1.716 0-3.294-.399-4.732-1.196a9.092 9.092 0 0 1-3.406-3.328c-.832-1.439-1.248-3.05-1.248-4.836 0-1.785.416-3.389 1.248-4.81a9.092 9.092 0 0 1 3.406-3.328C24.968.887 26.546.488 28.262.488c1.716 0 3.284.399 4.706 1.196a8.665 8.665 0 0 1 3.38 3.328c.832 1.421 1.248 3.025 1.248 4.81 0 1.785-.416 3.397-1.248 4.836a8.901 8.901 0 0 1-3.38 3.328c-1.422.797-2.99 1.196-4.706 1.196Zm0-4.056c1.456 0 2.617-.485 3.484-1.456.884-.97 1.326-2.253 1.326-3.848 0-1.612-.442-2.895-1.326-3.848-.867-.97-2.028-1.456-3.484-1.456-1.474 0-2.652.477-3.536 1.43-.867.953-1.3 2.245-1.3 3.874 0 1.612.433 2.903 1.3 3.874.884.953 2.062 1.43 3.536 1.43ZM49.377 19l-3.796-6.89h-1.066V19h-4.446V.748h7.462c1.439 0 2.66.251 3.666.754 1.023.503 1.785 1.196 2.288 2.08.503.867.754 1.837.754 2.912 0 1.213-.347 2.297-1.04 3.25-.676.953-1.681 1.63-3.016 2.028L54.395 19h-5.018ZM44.515 8.964h2.756c.815 0 1.421-.2 1.82-.598.416-.399.624-.962.624-1.69 0-.693-.208-1.24-.624-1.638-.399-.399-1.005-.598-1.82-.598h-2.756v4.524ZM61.476.748V19H57.03V.748h4.446ZM69.43 15.36h7.852V19H64.386v-3.38l7.8-11.232h-7.8V.748h12.896v3.38L69.43 15.36Zm19.388 3.822c-1.716 0-3.293-.399-4.732-1.196a9.093 9.093 0 0 1-3.406-3.328c-.832-1.439-1.248-3.05-1.248-4.836 0-1.785.416-3.389 1.248-4.81a9.093 9.093 0 0 1 3.406-3.328C85.525.887 87.102.488 88.818.488c1.716 0 3.285.399 4.706 1.196a8.664 8.664 0 0 1 3.38 3.328c.832 1.421 1.248 3.025 1.248 4.81 0 1.785-.416 3.397-1.248 4.836a8.9 8.9 0 0 1-3.38 3.328c-1.421.797-2.99 1.196-4.706 1.196Zm0-4.056c1.456 0 2.618-.485 3.484-1.456.884-.97 1.326-2.253 1.326-3.848 0-1.612-.442-2.895-1.326-3.848-.866-.97-2.028-1.456-3.484-1.456-1.473 0-2.652.477-3.536 1.43-.866.953-1.3 2.245-1.3 3.874 0 1.612.434 2.903 1.3 3.874.884.953 2.063 1.43 3.536 1.43ZM116.954 19h-4.446l-7.436-11.258V19h-4.446V.748h4.446l7.436 11.31V.748h4.446V19ZM136.32.878v1.924h-7.878v6.11h6.396v1.924h-6.396V19h-2.366V.878h10.244ZM148.72 19l-4.316-7.41h-2.86V19h-2.366V.878h5.85c1.369 0 2.522.234 3.458.702.953.468 1.664 1.1 2.132 1.898.468.797.702 1.707.702 2.73 0 1.248-.364 2.349-1.092 3.302-.711.953-1.786 1.586-3.224 1.898l4.55 7.592h-2.834Zm-7.176-9.308h3.484c1.282 0 2.244-.312 2.886-.936.641-.641.962-1.49.962-2.548 0-1.075-.321-1.907-.962-2.496-.624-.59-1.586-.884-2.886-.884h-3.484v6.864Zm15.818-6.89V8.86h6.604v1.95h-6.604v6.24h7.384V19h-9.75V.852h9.75v1.95h-7.384Zm13.33 0V8.86h6.604v1.95h-6.604v6.24h7.384V19h-9.75V.852h9.75v1.95h-7.384Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const SupportIcon = createIcon({
  // Doesn't display the full icon without w and h being specified
  displayName: "BuildIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M20.885 5.547a.703.703 0 00-1.122-.176l-2.7 2.702a.708.708 0 01-.995 0l-1.167-1.169a.702.702 0 010-.994l2.689-2.69a.704.704 0 00-.21-1.138c-2.031-.908-4.566-.435-6.164 1.152-1.358 1.348-1.763 3.455-1.11 5.78a.698.698 0 01-.197.703L2.593 16.4a2.82 2.82 0 103.981 3.983l6.754-7.332a.699.699 0 01.693-.2 7.885 7.885 0 002.03.279c1.469 0 2.757-.475 3.686-1.39 1.72-1.695 1.983-4.57 1.148-6.192zM4.623 19.901a1.407 1.407 0 11-.305-2.797 1.407 1.407 0 01.305 2.797z"
    />
  ),
});

export const StatsIcon = createIcon({
  displayName: "StatsIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z"
    />
  ),
});

export const WalletIcon = createIcon({
  displayName: "WalletIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z"
      />
      <path
        fill="currentColor"
        d="M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z"
      />
    </g>
  ),
});

export const VisaIcon = createIcon({
  displayName: "VisaIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      width="26"
      height="20"
      viewBox="0 0 30 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const BitcoinLogo = createIcon({
  displayName: "BitcoinLogo",
  viewBox: "0 0 67 14",
  path: (
    <svg width="67" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.779 8.694A6.993 6.993 0 1 1 .209 5.308a6.992 6.992 0 1 1 13.57 3.386Z"
        fill="#F7931A"
      />
      <path
        d="M10.078 6.004c.14-.932-.57-1.433-1.539-1.767l.315-1.261-.768-.192-.306 1.229c-.202-.05-.409-.098-.615-.145l.309-1.237-.768-.191-.314 1.26a25.67 25.67 0 0 1-.49-.115v-.004l-1.058-.264-.204.82s.57.13.558.139c.31.077.367.283.357.446L5.197 6.16c.021.005.05.013.08.025l-.081-.02-.502 2.014c-.038.094-.135.236-.352.182.008.011-.558-.14-.558-.14l-.38.88.998.249.547.141-.317 1.276.766.192.315-1.263c.21.057.412.11.611.16l-.313 1.256.767.191.318-1.274c1.309.248 2.293.148 2.707-1.036.334-.954-.016-1.504-.705-1.863.501-.116.88-.446.98-1.127Zm-1.754 2.46c-.237.954-1.842.438-2.362.31l.422-1.692c.52.13 2.188.388 1.94 1.382Zm.238-2.474c-.217.867-1.552.427-1.986.318l.383-1.533c.433.108 1.828.31 1.603 1.215Zm11.936-1.754c.568 0 1.058.102 1.47.302.413.201.755.473 1.029.815.27.343.471.744.6 1.204.13.462.195.958.195 1.489 0 .815-.15 1.586-.451 2.312a5.995 5.995 0 0 1-1.23 1.896 5.786 5.786 0 0 1-1.842 1.274 5.617 5.617 0 0 1-2.3.47c-.107 0-.295-.003-.56-.008a8.166 8.166 0 0 1-.91-.08 10.687 10.687 0 0 1-1.09-.213 5.458 5.458 0 0 1-1.089-.39L17.383.428l2.744-.425-1.097 4.57a4.19 4.19 0 0 1 .707-.247c.237-.06.49-.09.761-.09Zm-2.3 7.584c.412 0 .802-.101 1.167-.301.367-.2.684-.47.949-.806a4.07 4.07 0 0 0 .628-1.143 3.9 3.9 0 0 0 .23-1.33c0-.567-.094-1.009-.283-1.329-.189-.318-.538-.478-1.045-.478-.166 0-.38.032-.645.088a1.61 1.61 0 0 0-.718.373l-1.168 4.854c.07.012.133.024.186.035a1.918 1.918 0 0 0 .38.037h.318Zm8.439 1.932h-2.62l2.212-9.318h2.638l-2.23 9.317Zm1.275-10.454c-.366 0-.698-.109-.992-.327-.297-.217-.443-.551-.443-1.001 0-.248.05-.48.15-.7A1.87 1.87 0 0 1 27.6.323c.219-.094.452-.14.7-.14.366 0 .695.108.99.326.295.22.443.554.443 1.002 0 .248-.05.481-.15.7a1.844 1.844 0 0 1-.974.947c-.219.096-.45.141-.698.141Zm3.252-1.186 2.744-.425-.674 2.746h2.94l-.531 2.16H32.72l-.778 3.26a3.69 3.69 0 0 0-.124.761c-.013.237.017.44.088.612a.77.77 0 0 0 .38.398c.184.095.445.143.788.143.283 0 .558-.027.825-.08.264-.053.533-.126.804-.222l.196 2.02c-.355.13-.738.242-1.151.337a6.62 6.62 0 0 1-1.47.14c-.814 0-1.445-.12-1.895-.361-.449-.243-.766-.574-.956-.994-.187-.418-.271-.9-.248-1.442a9.351 9.351 0 0 1 .248-1.72l1.736-7.333Zm4.894 7.918c0-.802.13-1.559.39-2.267A5.58 5.58 0 0 1 37.563 5.9a5.215 5.215 0 0 1 1.762-1.257c.689-.306 1.46-.46 2.31-.46.531 0 1.006.05 1.424.15.42.102.8.234 1.143.399l-.904 2.056a8.454 8.454 0 0 0-.734-.257 3.194 3.194 0 0 0-.93-.116c-.874 0-1.566.302-2.08.903-.513.602-.77 1.412-.77 2.428 0 .602.129 1.09.39 1.462.259.372.738.558 1.433.558a4.841 4.841 0 0 0 1.842-.372l.196 2.108a9.48 9.48 0 0 1-1.098.347c-.402.098-.88.149-1.435.149-.732 0-1.352-.107-1.859-.319a3.54 3.54 0 0 1-1.256-.859 3.24 3.24 0 0 1-.717-1.268 5.205 5.205 0 0 1-.223-1.522Zm11.641 3.969c-.626 0-1.17-.096-1.63-.284a3.009 3.009 0 0 1-1.141-.797 3.443 3.443 0 0 1-.682-1.214 4.903 4.903 0 0 1-.229-1.548c0-.71.114-1.42.345-2.128a6.032 6.032 0 0 1 1.018-1.912 5.441 5.441 0 0 1 1.646-1.393c.648-.359 1.392-.54 2.23-.54.613 0 1.154.096 1.62.285a3.03 3.03 0 0 1 1.152.797c.299.343.527.746.68 1.214.154.465.23.983.23 1.55a7.06 7.06 0 0 1-.336 2.126 6.143 6.143 0 0 1-.991 1.913 5.198 5.198 0 0 1-1.637 1.39c-.655.36-1.414.54-2.275.54Zm1.31-7.582c-.39 0-.733.112-1.027.335a2.894 2.894 0 0 0-.743.851 4.202 4.202 0 0 0-.453 1.125 4.87 4.87 0 0 0-.149 1.16c0 .591.095 1.052.283 1.383.19.33.53.496 1.027.496.39 0 .731-.112 1.027-.337.293-.224.542-.508.743-.85.2-.342.352-.718.453-1.126.099-.406.15-.794.15-1.16 0-.59-.096-1.051-.285-1.382-.189-.33-.531-.495-1.027-.495Zm6.784 7.335h-2.622l2.212-9.318h2.64l-2.23 9.317Zm1.273-10.454c-.365 0-.697-.109-.99-.327-.296-.217-.444-.551-.444-1.001 0-.248.051-.48.151-.7.1-.218.233-.406.399-.566.164-.16.358-.286.575-.382.218-.094.45-.14.698-.14.367 0 .698.108.992.326.295.22.444.554.444 1.002 0 .248-.053.481-.152.7a1.837 1.837 0 0 1-.972.947 1.73 1.73 0 0 1-.7.141Zm2.845 1.559c.2-.058.422-.128.663-.204a9.764 9.764 0 0 1 1.824-.371c.372-.043.795-.063 1.265-.063 1.382 0 2.335.402 2.86 1.205.526.804.617 1.902.276 3.295l-1.205 5.032h-2.638l1.168-4.926c.072-.307.127-.604.169-.895a2.12 2.12 0 0 0-.01-.761.911.911 0 0 0-.326-.532c-.173-.136-.434-.204-.789-.204a5.32 5.32 0 0 0-1.044.108l-1.717 7.21h-2.639l2.143-8.894Z"
        fill="#fff"
      />
    </svg>
  ),
});

export const EthereumLogoOutline = createIcon({
  displayName: "EthereumLogoOutline",
  viewBox: "0 0 82 82",
  path: (
    <svg width="82" height="82" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41 82c22.644 0 41-18.356 41-41S63.644 0 41 0 0 18.356 0 41s18.356 41 41 41Zm-.1-33.852-12.625-7.146 12.627 17.054L53.54 41.002 40.9 48.148Zm-12.436-9.44 12.632-20.082 12.628 20.088-12.63 7.147-12.63-7.154Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const DashCurveUp = createIcon({
  displayName: "DashCurveUp",
  viewBox: "0 0 134 22",
  path: (
    <g width="134" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 21v0C41.269-4.626 92.731-4.626 133 21v0"
        stroke="currentColor"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-dasharray="6 6"
      />
    </g>
  ),
});
export const DashCurveDown = createIcon({
  displayName: "DashCurveDown",
  viewBox: "0 0 134 22",
  path: (
    <g width="134" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1v0c40.269 25.626 91.731 25.626 132 0v0"
        stroke="currentColor"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-dasharray="6 6"
      />
    </g>
  ),
});

export const ButtonLeft = createIcon({
  displayName: "ButtonLeft",
  viewBox: "0 0 44 29",
  path: (
    <g width="44" height="29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 9.024A5 5 0 0 1 5.606 4.04l32-2.531A5 5 0 0 1 43 6.493v16.014a5 5 0 0 1-5.394 4.984l-32-2.53A5 5 0 0 1 1 19.975V9.024Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
  ),
});

export const ButtonRight = createIcon({
  displayName: "ButtonRight",
  viewBox: "0 0 44 29",
  path: (
    <svg width="44" height="29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M43 9.024a5 5 0 0 0-4.606-4.984l-32-2.531A5 5 0 0 0 1 6.493v16.014a5 5 0 0 0 5.394 4.984l32-2.53A5 5 0 0 0 43 19.975V9.024Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
});

export const Fingerprint = createIcon({
  displayName: "ButtonRight",
  viewBox: "0 0 48 48",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <path
        fill="currentColor"
        d="M24.15 3.7Q27.45 3.7 30.625 4.5Q33.8 5.3 36.7 6.8Q37.15 7.05 37.225 7.425Q37.3 7.8 37.15 8.1Q36.95 8.4 36.6 8.575Q36.25 8.75 35.85 8.5Q33.2 7.1 30.2 6.375Q27.2 5.65 24.15 5.65Q21.05 5.65 18.1 6.35Q15.15 7.05 12.45 8.5Q11.95 8.75 11.6 8.65Q11.25 8.55 11.1 8.25Q10.9 8.05 10.975 7.6Q11.05 7.15 11.4 6.95Q14.3 5.3 17.575 4.5Q20.85 3.7 24.15 3.7ZM24.15 8.65Q29.5 8.65 34.25 10.975Q39 13.3 42.1 17.65Q42.4 18.1 42.325 18.475Q42.25 18.85 41.95 19.1Q41.65 19.35 41.25 19.325Q40.85 19.3 40.6 18.85Q37.8 14.9 33.425 12.775Q29.05 10.65 24.15 10.6Q19.2 10.6 14.875 12.725Q10.55 14.85 7.8 18.9Q7.45 19.35 7.05 19.425Q6.65 19.5 6.35 19.3Q6 19.15 5.925 18.775Q5.85 18.4 6 18.05Q9.05 13.6 13.85 11.125Q18.65 8.65 24.15 8.65ZM24.15 18.55Q28.8 18.55 32.125 21.725Q35.45 24.9 35.45 29.45Q35.45 29.95 35.225 30.275Q35 30.6 34.5 30.6Q33.95 30.6 33.7 30.275Q33.45 29.95 33.45 29.45Q33.45 25.65 30.725 23.05Q28 20.45 24.15 20.45Q20.3 20.45 17.6 23.15Q14.9 25.85 14.9 29.65Q14.9 33.65 16.15 36.625Q17.4 39.6 20.25 42.55Q20.6 42.9 20.6 43.25Q20.6 43.6 20.4 43.85Q20.15 44.2 19.625 44.175Q19.1 44.15 18.75 43.8Q15.9 40.8 14.425 37.35Q12.95 33.9 12.95 29.65Q12.95 25.05 16.2 21.8Q19.45 18.55 24.15 18.55ZM24.15 28.45Q24.6 28.45 24.85 28.75Q25.1 29.05 25.1 29.5Q25.1 33.9 27.975 36.2Q30.85 38.5 34.85 38.5Q35.35 38.5 36 38.4Q36.65 38.3 37.2 38.3Q37.6 38.3 37.875 38.55Q38.15 38.8 38.1 39.1Q38.1 39.5 37.925 39.725Q37.75 39.95 37.45 40.05Q36.75 40.3 36.025 40.35Q35.3 40.4 34.85 40.4Q30 40.4 26.6 37.575Q23.2 34.75 23.2 29.5Q23.2 29.05 23.45 28.75Q23.7 28.45 24.15 28.45ZM24.15 23.5Q26.7 23.5 28.5 25.225Q30.3 26.95 30.3 29.45Q30.3 31.2 31.525 32.4Q32.75 33.6 34.5 33.6Q36.2 33.6 37.4 32.4Q38.6 31.2 38.6 29.45Q38.6 23.6 34.35 19.625Q30.1 15.65 24.1 15.65Q18.1 15.65 13.9 19.725Q9.7 23.8 9.7 29.7Q9.7 31.55 9.975 33.35Q10.25 35.15 10.9 36.85Q11.05 37.35 10.925 37.65Q10.8 37.95 10.45 38.1Q10.05 38.25 9.65 38.15Q9.25 38.05 9.05 37.5Q8.55 36.05 8.175 34.025Q7.8 32 7.8 29.65Q7.8 23.1 12.625 18.325Q17.45 13.55 24.15 13.55Q30.95 13.55 35.75 18.175Q40.55 22.8 40.55 29.45Q40.55 31.95 38.8 33.75Q37.05 35.55 34.5 35.55Q31.9 35.55 30.1 33.825Q28.3 32.1 28.3 29.65Q28.3 27.9 27.1 26.65Q25.9 25.4 24.15 25.4Q22.45 25.4 21.225 26.65Q20 27.9 20 29.65Q20 34.75 22.9 38.225Q25.8 41.7 31.1 42.9Q31.55 42.95 31.725 43.275Q31.9 43.6 31.8 43.95Q31.75 44.35 31.45 44.55Q31.15 44.75 30.55 44.65Q24.7 43.45 21.375 39.375Q18.05 35.3 18.05 29.65Q18.05 27.1 19.825 25.3Q21.6 23.5 24.15 23.5Z"
      />
    </g>
  ),
});

// New Icons

export const LanguexLogo = createIcon({
  displayName: "languexLogo",
  viewBox: "0 0 42 42",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="42" width="42">
      <path
        d="M41.5991 24C41.5991 24 41.8061 24 41.5991 24C41.8061 24 41.8061 24 41.5991 24C41.8061 22.9655 41.8061 21.931 41.8061 20.8966C42.013 9.31035 32.4928 0 20.903 0C9.31323 0 0 9.31035 0 20.8966C0 32.4828 9.31323 41.7931 20.903 41.7931C21.317 41.7931 21.7309 41.7931 22.1448 41.7931C22.3518 41.7931 22.5587 41.7931 22.7657 41.7931C23.1796 41.7931 23.5935 41.5862 24.0074 41.5862C24.2144 41.5862 24.4214 41.5862 24.6283 41.3793C25.0422 41.3793 25.4562 41.1724 25.8701 41.1724C26.077 41.1724 26.284 40.9655 26.491 40.9655C26.9049 40.7586 27.3188 40.7586 27.7327 40.5517C27.9397 40.5517 28.1467 40.3448 28.3536 40.3448C28.7675 40.1379 29.1815 39.931 29.5954 39.7241C29.8023 39.7241 30.0093 39.5172 30.2163 39.5172C30.6302 39.3103 31.0441 39.1034 31.458 38.8966C31.665 38.8966 31.665 38.6897 31.8719 38.6897C32.2859 38.4828 32.6998 38.2759 33.1137 37.8621C33.3207 37.8621 33.3207 37.6552 33.5276 37.6552C33.9416 37.4483 34.3555 37.0345 34.7694 36.8276L34.9764 36.6207C38.0808 33.7241 40.3573 30.2069 41.3921 25.8621C41.3921 25.2414 41.5991 24.6207 41.5991 24ZM40.7713 20.8966C40.7713 21.7241 40.7713 22.3448 40.5643 23.1724C39.3225 33.1035 31.0441 40.7586 20.903 40.7586C18.0056 40.7586 15.729 38.4828 15.729 35.5862C15.729 32.6897 18.0056 30.4138 20.903 30.4138C22.9726 30.4138 25.0422 29.5862 26.6979 28.3448L31.458 30C32.4928 30.4138 33.3207 29.3793 32.6998 28.3448L30.0093 24C30.4232 22.9655 30.6302 21.7241 30.6302 20.4828C30.6302 16.3448 27.7327 12.8276 24.0074 11.5862C26.077 10.5517 27.5258 8.48276 27.5258 6C27.5258 4.13793 26.6979 2.68966 25.6631 1.44828C34.1485 3.72414 40.7713 11.5862 40.7713 20.8966ZM26.077 6.41379C26.077 9.31035 23.8005 11.5862 20.903 11.5862C15.729 11.5862 11.3828 15.931 11.3828 21.1034C11.3828 25.2414 14.0733 28.9655 18.0056 30.2069C15.936 31.2414 14.4872 33.3103 14.4872 35.7931C14.4872 37.6552 15.3151 39.1035 16.3499 40.3448C7.65755 38.2759 1.0348 30.4138 1.0348 21.1034C1.0348 10.1379 9.93411 1.44828 20.6961 1.44828C23.8005 1.24138 26.077 3.51724 26.077 6.41379Z"
        fill="white"
      />
      <path
        d="M1.24121 20.8962C1.24121 30.2066 7.86395 38.0687 16.5563 40.1376C15.3145 38.8962 14.6937 37.448 14.6937 35.5859C14.6937 33.1031 16.1424 31.0342 18.212 29.9997C14.4867 28.7583 11.5892 25.2411 11.5892 20.8962C11.5892 15.7238 15.9354 11.379 21.1094 11.379C24.0069 11.379 26.2835 9.10314 26.2835 6.20659C26.2835 3.31004 24.0069 1.03418 21.1094 1.03418C10.1405 1.24108 1.24121 10.1376 1.24121 20.8962Z"
        fill="#37474F"
      />
      <path
        d="M25.4561 1.8623C26.6978 3.10368 27.3187 4.55196 27.3187 6.41403C27.3187 8.89679 25.87 10.9658 23.8004 12.0002C27.5257 13.2416 30.4231 16.7589 30.4231 20.8968C30.4231 22.1382 30.2162 23.3795 29.8023 24.414L32.4927 28.7589C33.1136 29.5864 32.2858 30.6209 31.251 30.414L26.4909 28.7589C24.8352 30.0002 22.9726 30.8278 20.696 30.8278C17.7985 30.8278 15.522 33.1037 15.522 36.0002C15.522 38.8968 17.7985 41.1727 20.696 41.1727C30.8371 41.1727 39.1155 33.5175 40.3573 23.7933C40.3573 22.9658 40.5642 22.3451 40.5642 21.5175C40.7712 11.5864 34.1484 3.72437 25.4561 1.8623Z"
        fill="url(#paint0_linear_295_5110)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_295_5110"
          x1="28.284"
          y1="36.7173"
          x2="28.284"
          y2="9.64099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#34AD68" />
          <stop offset="1" stopColor="#29B6F6" />
        </linearGradient>
      </defs>
    </g>
  ),
});

export const IconDashboard = createIcon({
  displayName: "dashboardIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92906 5.26281C7.65784 5.12073 6.34193 5.12073 5.07071 5.26281C4.76182 5.29733 4.51823 5.54192 4.48348 5.83898C4.33168 7.13692 4.33168 8.44813 4.48348 9.74607C4.51823 10.0431 4.76182 10.2877 5.07071 10.3222C6.34193 10.4643 7.65784 10.4643 8.92906 10.3222C9.23795 10.2877 9.48154 10.0431 9.51629 9.74607C9.66809 8.44813 9.66809 7.13692 9.51629 5.83898C9.48154 5.54192 9.23795 5.29733 8.92906 5.26281ZM4.9041 3.77209C6.28605 3.61764 7.71372 3.61764 9.09567 3.77209C10.0865 3.88283 10.889 4.66282 11.0061 5.66473C11.1715 7.07844 11.1715 8.50661 11.0061 9.92032C10.889 10.9222 10.0865 11.7022 9.09567 11.813C7.71372 11.9674 6.28605 11.9674 4.90411 11.813C3.91327 11.7022 3.11082 10.9222 2.99364 9.92032C2.82829 8.50661 2.82829 7.07844 2.99364 5.66473C3.11082 4.66282 3.91326 3.88283 4.9041 3.77209Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92906 15.2628C7.65784 15.1207 6.34193 15.1207 5.07071 15.2628C4.76182 15.2973 4.51823 15.5419 4.48348 15.839C4.33168 17.1369 4.33168 18.4481 4.48348 19.7461C4.51823 20.0431 4.76182 20.2877 5.07071 20.3222C6.34193 20.4643 7.65784 20.4643 8.92906 20.3222C9.23795 20.2877 9.48154 20.0431 9.51629 19.7461C9.66809 18.4481 9.66809 17.1369 9.51629 15.839C9.48154 15.5419 9.23795 15.2973 8.92906 15.2628ZM4.9041 13.7721C6.28605 13.6176 7.71372 13.6176 9.09567 13.7721C10.0865 13.8828 10.889 14.6628 11.0061 15.6647C11.1715 17.0784 11.1715 18.5066 11.0061 19.9203C10.889 20.9222 10.0865 21.7022 9.09567 21.813C7.71372 21.9674 6.28605 21.9674 4.90411 21.813C3.91327 21.7022 3.11082 20.9222 2.99364 19.9203C2.82829 18.5066 2.82829 17.0784 2.99364 15.6647C3.11082 14.6628 3.91326 13.8828 4.9041 13.7721Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9291 5.26281C17.6578 5.12073 16.3419 5.12073 15.0707 5.26281C14.7618 5.29733 14.5182 5.54192 14.4835 5.83898C14.3317 7.13692 14.3317 8.44813 14.4835 9.74607C14.5182 10.0431 14.7618 10.2877 15.0707 10.3222C16.3419 10.4643 17.6578 10.4643 18.9291 10.3222C19.2379 10.2877 19.4815 10.0431 19.5163 9.74607C19.6681 8.44813 19.6681 7.13692 19.5163 5.83898C19.4815 5.54192 19.2379 5.29733 18.9291 5.26281ZM14.9041 3.77209C16.2861 3.61764 17.7137 3.61764 19.0957 3.77209C20.0865 3.88283 20.889 4.66282 21.0061 5.66473C21.1715 7.07844 21.1715 8.50661 21.0061 9.92032C20.889 10.9222 20.0865 11.7022 19.0957 11.813C17.7137 11.9674 16.2861 11.9674 14.9041 11.813C13.9133 11.7022 13.1108 10.9222 12.9936 9.92032C12.8283 8.50661 12.8283 7.07844 12.9936 5.66473C13.1108 4.66282 13.9133 3.88283 14.9041 3.77209Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9291 15.2628C17.6578 15.1207 16.3419 15.1207 15.0707 15.2628C14.7618 15.2973 14.5182 15.5419 14.4835 15.839C14.3317 17.1369 14.3317 18.4481 14.4835 19.7461C14.5182 20.0431 14.7618 20.2877 15.0707 20.3222C16.3419 20.4643 17.6578 20.4643 18.9291 20.3222C19.2379 20.2877 19.4815 20.0431 19.5163 19.7461C19.6681 18.4481 19.6681 17.1369 19.5163 15.839C19.4815 15.5419 19.2379 15.2973 18.9291 15.2628ZM14.9041 13.7721C16.2861 13.6176 17.7137 13.6176 19.0957 13.7721C20.0865 13.8828 20.889 14.6628 21.0061 15.6647C21.1715 17.0784 21.1715 18.5066 21.0061 19.9203C20.889 20.9222 20.0865 21.7022 19.0957 21.813C17.7137 21.9674 16.2861 21.9674 14.9041 21.813C13.9133 21.7022 13.1108 20.9222 12.9936 19.9203C12.8283 18.5066 12.8283 17.0784 12.9936 15.6647C13.1108 14.6628 13.9133 13.8828 14.9041 13.7721Z"
        fill="black"
      />
    </g>
  ),
});

export const IconTeam = createIcon({
  displayName: "teamIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        d="M13.5 10.5432C13.5 10.129 13.1642 9.79317 12.75 9.79317H6.75C6.33579 9.79317 6 10.129 6 10.5432C6 10.9574 6.33579 11.2932 6.75 11.2932H12.75C13.1642 11.2932 13.5 10.9574 13.5 10.5432Z"
        fill="black"
      />
      <path
        d="M12.5 13.5432C12.5 13.129 12.1642 12.7932 11.75 12.7932H6.75C6.33579 12.7932 6 13.129 6 13.5432C6 13.9574 6.33579 14.2932 6.75 14.2932H11.75C12.1642 14.2932 12.5 13.9574 12.5 13.5432Z"
        fill="black"
      />
      <path
        d="M12.75 15.7932C13.1642 15.7932 13.5 16.129 13.5 16.5432C13.5 16.9574 13.1642 17.2932 12.75 17.2932H6.75C6.33579 17.2932 6 16.9574 6 16.5432C6 16.129 6.33579 15.7932 6.75 15.7932H12.75Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 22.5432H19C20.5188 22.5432 21.75 21.312 21.75 19.7932V14.2932C21.75 13.879 21.4142 13.5432 21 13.5432H17.75V5.73636C17.75 4.31296 16.1411 3.48499 14.9828 4.31233L14.8078 4.43736C14.0273 4.99486 12.9701 4.99298 12.1859 4.43287C10.8821 3.50154 9.11794 3.50154 7.81407 4.43287C7.02992 4.99298 5.9727 4.99486 5.19221 4.43736L5.01717 4.31233C3.8589 3.48499 2.25 4.31296 2.25 5.73636V18.7932C2.25 20.8642 3.92893 22.5432 6 22.5432ZM8.68593 5.65347C9.46825 5.09468 10.5318 5.09468 11.3141 5.65347C12.6161 6.5835 14.3739 6.5906 15.6796 5.65796L15.8547 5.53293C16.0202 5.41474 16.25 5.53302 16.25 5.73636V19.7932C16.25 20.2433 16.3581 20.6681 16.5499 21.0432H6C4.75736 21.0432 3.75 20.0358 3.75 18.7932V5.73636C3.75 5.53302 3.97984 5.41474 4.14531 5.53293L4.32036 5.65796C5.62605 6.5906 7.3839 6.5835 8.68593 5.65347ZM17.75 19.7932V15.0432H20.25V19.7932C20.25 20.4835 19.6904 21.0432 19 21.0432C18.3096 21.0432 17.75 20.4835 17.75 19.7932Z"
        fill="black"
      />
    </g>
  ),
});

export const IconCustomers = createIcon({
  displayName: "customerIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.455 6.20872C21.6473 6.49983 21.6152 6.89544 21.3589 7.15173L12.1666 16.3441C12.0723 16.4383 11.9547 16.5058 11.8258 16.5394L7.99734 17.5394C7.87247 17.5721 7.74376 17.5714 7.62283 17.5406C7.49427 17.5079 7.37449 17.4411 7.27748 17.3441C7.0892 17.1558 7.01486 16.8819 7.08215 16.6242L8.08215 12.7958C8.11162 12.683 8.16691 12.5716 8.2434 12.4842L17.4699 3.26264C17.5506 3.18187 17.6479 3.12143 17.7538 3.0846C17.8323 3.05729 17.9155 3.04297 18.0002 3.04297C18.1991 3.04297 18.3899 3.12199 18.5305 3.26264L21.3589 6.09107C21.3956 6.12768 21.4276 6.16713 21.455 6.20872ZM19.768 6.6214L18.0002 4.85363L9.48202 13.3718L8.85703 15.7646L11.2498 15.1396L19.768 6.6214Z"
        fill="black"
      />
      <path
        d="M19.6415 17.9533C19.9149 15.6157 20.0019 13.2617 19.9025 10.9138C19.8978 10.8013 19.94 10.692 20.0196 10.6124L21.0029 9.62906C21.1238 9.50816 21.3304 9.58491 21.3417 9.75551C21.5266 12.5452 21.4565 15.3475 21.1314 18.1275C20.8948 20.1501 19.2705 21.7351 17.2584 21.9599C13.7919 22.3474 10.2085 22.3474 6.74195 21.9599C4.7299 21.7351 3.10556 20.1501 2.86901 18.1275C2.45447 14.5832 2.45447 11.0027 2.86901 7.4584C3.10556 5.43587 4.7299 3.85086 6.74195 3.62598C9.3717 3.33207 12.0686 3.26112 14.7308 3.41313C14.9024 3.42293 14.9806 3.63054 14.8591 3.75206L13.8666 4.74462C13.7879 4.82331 13.6799 4.86557 13.5687 4.86182C11.3423 4.78673 9.10074 4.87169 6.90856 5.1167C5.57846 5.26536 4.51297 6.31497 4.35885 7.63265C3.95786 11.0612 3.95786 14.5248 4.35885 17.9533C4.51297 19.271 5.57845 20.3206 6.90856 20.4692C10.2644 20.8443 13.736 20.8443 17.0918 20.4692C18.4219 20.3206 19.4874 19.271 19.6415 17.9533Z"
        fill="black"
      />
    </g>
  ),
});

export const IconServices = createIcon({
  displayName: "serviceIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.455 6.20872C21.6473 6.49983 21.6152 6.89544 21.3589 7.15173L12.1666 16.3441C12.0723 16.4383 11.9547 16.5058 11.8258 16.5394L7.99734 17.5394C7.87247 17.5721 7.74376 17.5714 7.62283 17.5406C7.49427 17.5079 7.37449 17.4411 7.27748 17.3441C7.0892 17.1558 7.01486 16.8819 7.08215 16.6242L8.08215 12.7958C8.11162 12.683 8.16691 12.5716 8.2434 12.4842L17.4699 3.26264C17.5506 3.18187 17.6479 3.12143 17.7538 3.0846C17.8323 3.05729 17.9155 3.04297 18.0002 3.04297C18.1991 3.04297 18.3899 3.12199 18.5305 3.26264L21.3589 6.09107C21.3956 6.12768 21.4276 6.16713 21.455 6.20872ZM19.768 6.6214L18.0002 4.85363L9.48202 13.3718L8.85703 15.7646L11.2498 15.1396L19.768 6.6214Z"
        fill="black"
      />
      <path
        d="M19.6415 17.9533C19.9149 15.6157 20.0019 13.2617 19.9025 10.9138C19.8978 10.8013 19.94 10.692 20.0196 10.6124L21.0029 9.62906C21.1238 9.50816 21.3304 9.58491 21.3417 9.75551C21.5266 12.5452 21.4565 15.3475 21.1314 18.1275C20.8948 20.1501 19.2705 21.7351 17.2584 21.9599C13.7919 22.3474 10.2085 22.3474 6.74195 21.9599C4.7299 21.7351 3.10556 20.1501 2.86901 18.1275C2.45447 14.5832 2.45447 11.0027 2.86901 7.4584C3.10556 5.43587 4.7299 3.85086 6.74195 3.62598C9.3717 3.33207 12.0686 3.26112 14.7308 3.41313C14.9024 3.42293 14.9806 3.63054 14.8591 3.75206L13.8666 4.74462C13.7879 4.82331 13.6799 4.86557 13.5687 4.86182C11.3423 4.78673 9.10074 4.87169 6.90856 5.1167C5.57846 5.26536 4.51297 6.31497 4.35885 7.63265C3.95786 11.0612 3.95786 14.5248 4.35885 17.9533C4.51297 19.271 5.57845 20.3206 6.90856 20.4692C10.2644 20.8443 13.736 20.8443 17.0918 20.4692C18.4219 20.3206 19.4874 19.271 19.6415 17.9533Z"
        fill="black"
      />
    </g>
  ),
});

export const IconSupport = createIcon({
  displayName: "supportIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.04297C7.02944 3.04297 3 7.07241 3 12.043C3 13.7891 3.50639 15.4178 4.38326 16.7935L3.09202 20.6614C2.93227 21.1401 3.40285 21.6107 3.88156 21.451L7.74952 20.1597C9.12519 21.0366 10.7539 21.543 12.5 21.543C17.4706 21.543 21.5 17.5135 21.5 12.543C21.5 7.57241 17.4706 3.54297 12.5 3.54297C12.3329 3.54297 12.1663 3.54631 12 3.55294V3.04297ZM12 5.04297C16.4183 5.04297 20 8.62469 20 13.043C20 17.4612 16.4183 21.043 12 21.043C10.4541 21.043 9.01428 20.5965 7.79772 19.8227L7.40961 19.5759L4.5 20.543L5.46711 17.6334L5.22029 17.2453C4.44651 16.0287 4 14.5889 4 13.043C4 8.62469 7.58172 5.04297 12 5.04297ZM8.5 11.543C8.5 11.2668 8.72386 11.043 9 11.043H15C15.2761 11.043 15.5 11.2668 15.5 11.543C15.5 11.8191 15.2761 12.043 15 12.043H9C8.72386 12.043 8.5 11.8191 8.5 11.543ZM9 13.543C8.72386 13.543 8.5 13.7668 8.5 14.043C8.5 14.3191 8.72386 14.543 9 14.543H13C13.2761 14.543 13.5 14.3191 13.5 14.043C13.5 13.7668 13.2761 13.543 13 13.543H9Z"
        fill="black"
      />
    </g>
  ),
});

export const IconRewards = createIcon({
  displayName: "rewardsIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 6.29297C6.25 4.49804 7.70507 3.04297 9.5 3.04297C10.5052 3.04297 11.4038 3.49934 12 4.21618C12.5962 3.49934 13.4948 3.04297 14.5 3.04297C16.2949 3.04297 17.75 4.49804 17.75 6.29297C17.75 6.93729 17.5625 7.53782 17.2391 8.04297H18C19.5188 8.04297 20.75 9.27419 20.75 10.793V12.793C20.75 13.5971 20.2076 14.2746 19.4687 14.4795C19.6128 16.3061 19.5293 18.1446 19.2195 19.9527C19.0345 21.0324 18.1576 21.8594 17.069 21.9811L16.1545 22.0833C13.3934 22.3919 10.6066 22.3919 7.84548 22.0833L6.93101 21.9811C5.84239 21.8594 4.96552 21.0323 4.78052 19.9527C4.47069 18.1446 4.38724 16.3061 4.53131 14.4795C3.7924 14.2746 3.25 13.5971 3.25 12.793V10.793C3.25 9.27419 4.48122 8.04297 6 8.04297H6.76091C6.4375 7.53782 6.25 6.93729 6.25 6.29297ZM11.25 6.29297C11.25 5.32647 10.4665 4.54297 9.5 4.54297C8.5335 4.54297 7.75 5.32647 7.75 6.29297C7.75 7.25947 8.5335 8.04297 9.5 8.04297C10.4665 8.04297 11.25 7.25947 11.25 6.29297ZM14.5 8.04297C15.4665 8.04297 16.25 7.25947 16.25 6.29297C16.25 5.32647 15.4665 4.54297 14.5 4.54297C13.5335 4.54297 12.75 5.32647 12.75 6.29297C12.75 7.25947 13.5335 8.04297 14.5 8.04297ZM4.75 10.793C4.75 10.1026 5.30964 9.54297 6 9.54297H11.25V13.043H5C4.86193 13.043 4.75 12.931 4.75 12.793V10.793ZM12.75 14.543H17.969C18.1093 16.2636 18.0329 17.996 17.741 19.6993C17.6689 20.1204 17.3269 20.4429 16.9024 20.4904L15.9879 20.5926C14.9116 20.7129 13.8312 20.7843 12.75 20.8069V14.543ZM12.75 13.043H19C19.1381 13.043 19.25 12.931 19.25 12.793V10.793C19.25 10.1026 18.6904 9.54297 18 9.54297H12.75V13.043ZM11.25 14.543V20.8069C10.1688 20.7843 9.08842 20.7129 8.01209 20.5926L7.09762 20.4904C6.67308 20.4429 6.33112 20.1204 6.25897 19.6993C5.96708 17.996 5.89074 16.2636 6.03103 14.543H11.25Z"
        fill="black"
      />
    </g>
  ),
});

export const IconArrowRight = createIcon({
  displayName: "arrowRightIcon",
  viewBox: "0 0 39 40",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="40" width="39">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2007 12.9595C16.6767 12.4836 17.4483 12.4836 17.9243 12.9595L24.4243 19.4595C24.9002 19.9355 24.9002 20.7071 24.4243 21.1831L17.9243 27.6831C17.4483 28.159 16.6767 28.159 16.2007 27.6831C15.7248 27.2071 15.7248 26.4355 16.2007 25.9595L21.8389 20.3213L16.2007 14.6831C15.7248 14.2071 15.7248 13.4355 16.2007 12.9595Z"
        fill="black"
      />
    </g>
  ),
});

export const IconArrowDown = createIcon({
  displayName: "arrowDownIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5303 9.26264C16.8232 9.55553 16.8232 10.0304 16.5303 10.3233L12.5303 14.3233C12.2374 14.6162 11.7626 14.6162 11.4697 14.3233L7.46967 10.3233C7.17678 10.0304 7.17678 9.55553 7.46967 9.26264C7.76256 8.96975 8.23744 8.96975 8.53033 9.26264L12 12.7323L15.4697 9.26264C15.7626 8.96975 16.2374 8.96975 16.5303 9.26264Z"
        fill="black"
      />
    </g>
  ),
});

export const IconChecked = createIcon({
  displayName: "checkedIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="25">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9327 8.45112C19.2256 8.74401 19.2256 9.21888 18.9327 9.51178L11.9327 16.5118C11.6398 16.8047 11.1649 16.8047 10.872 16.5118L6.87201 12.5118C6.57912 12.2189 6.57912 11.744 6.87201 11.4511C7.16491 11.1582 7.63978 11.1582 7.93267 11.4511L11.4023 14.9208L17.872 8.45112C18.1649 8.15822 18.6398 8.15822 18.9327 8.45112Z"
        fill="#00B67A"
      />
    </g>
  ),
});

export const IconRoundedCheck = createIcon({
  displayName: "roundedCheckIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M20 6L9 17l-5-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export const IconWarning = createIcon({
  displayName: "warningIcon",
  viewBox: "0 0 21 19",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="19" width="21">
      <path
        d="M11.345 6.48101C11.345 7.03329 10.8973 7.48101 10.345 7.48101C9.79275 7.48101 9.34503 7.03329 9.34503 6.48101C9.34503 5.92872 9.79275 5.48101 10.345 5.48101C10.8973 5.48101 11.345 5.92872 11.345 6.48101Z"
        fill="#F02828"
      />
      <path
        d="M10.345 9.23101C10.7592 9.23101 11.095 9.56679 11.095 9.98101V14.981C11.095 15.3952 10.7592 15.731 10.345 15.731C9.93082 15.731 9.59503 15.3952 9.59503 14.981V9.98101C9.59503 9.56679 9.93082 9.23101 10.345 9.23101Z"
        fill="#F02828"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6154 1.47364C11.5234 -0.124023 9.16662 -0.124029 8.07464 1.47364L7.64272 2.10558C4.93668 6.0648 2.61172 10.2714 0.698989 14.6691L0.608774 14.8765C-0.065281 16.4263 0.953083 18.186 2.63263 18.3737C7.75826 18.9466 12.9318 18.9466 18.0574 18.3737C19.7369 18.186 20.7553 16.4263 20.0812 14.8765L19.991 14.6691C18.0783 10.2714 15.7533 6.0648 13.0473 2.10559L12.6154 1.47364ZM9.31303 2.32005C9.80938 1.59384 10.8806 1.59384 11.377 2.32005L11.8089 2.952C14.4615 6.83302 16.7406 10.9565 18.6155 15.2674L18.7057 15.4748C18.9771 16.0988 18.5671 16.8074 17.8908 16.883C12.8759 17.4435 7.81414 17.4435 2.79924 16.883C2.12294 16.8074 1.71288 16.0988 1.9843 15.4748L2.07451 15.2674C3.94947 10.9566 6.22851 6.83301 8.88111 2.95199L9.31303 2.32005Z"
        fill="#F02828"
      />
    </g>
  ),
});

export const IconTranslator = createIcon({
  displayName: "translatorIcon",
  viewBox: "0 0 17 16",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="16" width="17">
      <path
        d="M9.5127 11.6475C9.78884 11.6475 10.0127 11.4236 10.0127 11.1475C10.0127 10.8713 9.78884 10.6475 9.5127 10.6475L9.5127 11.6475ZM2.50561 10.7939C2.31035 10.9892 2.31035 11.3058 2.50561 11.501L5.68759 14.683C5.88285 14.8783 6.19943 14.8783 6.3947 14.683C6.58996 14.4877 6.58996 14.1712 6.3947 13.9759L3.56627 11.1475L6.3947 8.31903C6.58996 8.12377 6.58996 7.80719 6.3947 7.61193C6.19943 7.41666 5.88285 7.41666 5.68759 7.61193L2.50561 10.7939ZM9.5127 10.6475L2.85916 10.6475L2.85916 11.6475L9.5127 11.6475L9.5127 10.6475Z"
        fill="#8E8C8C"
      />
      <path
        d="M8.43164 5.26074C8.1555 5.26074 7.93164 5.4846 7.93164 5.76074C7.93164 6.03688 8.1555 6.26074 8.43164 6.26074V5.26074ZM15.4387 6.1143C15.634 5.91903 15.634 5.60245 15.4387 5.40719L12.2567 2.22521C12.0615 2.02995 11.7449 2.02995 11.5496 2.22521C11.3544 2.42047 11.3544 2.73705 11.5496 2.93232L14.3781 5.76074L11.5496 8.58917C11.3544 8.78443 11.3544 9.10101 11.5496 9.29628C11.7449 9.49154 12.0615 9.49154 12.2567 9.29628L15.4387 6.1143ZM8.43164 6.26074H15.0852V5.26074H8.43164V6.26074Z"
        fill="#DCDCDC"
      />
    </g>
  ),
});

export const IconClose = createIcon({
  displayName: "closeIcon",
  viewBox: "0 0 52 52",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="52" width="52">
      <path
        d="M18.3395 33.6605L33.6602 18.3398"
        stroke="#BDBDBD"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18.3395 18.3395L33.6602 33.6602"
        stroke="#BDBDBD"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
});

export const IconComments = createIcon({
  displayName: "commentsIcon",
  viewBox: "0 0 19 16",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="16" width="19">
      <path
        d="M5.55762 6.05595C4.86726 6.05595 4.30762 6.61559 4.30762 7.30595C4.30762 7.9963 4.86726 8.55595 5.55762 8.55595C6.24797 8.55595 6.80762 7.9963 6.80762 7.30595C6.80762 6.61559 6.24797 6.05595 5.55762 6.05595Z"
        fill="#2F80ED"
      />
      <path
        d="M9.55762 6.05595C8.86726 6.05595 8.30762 6.61559 8.30762 7.30595C8.30762 7.9963 8.86726 8.55595 9.55762 8.55595C10.248 8.55595 10.8076 7.9963 10.8076 7.30595C10.8076 6.61559 10.248 6.05595 9.55762 6.05595Z"
        fill="#2F80ED"
      />
      <path
        d="M12.3076 7.30595C12.3076 6.61559 12.8673 6.05595 13.5576 6.05595C14.248 6.05595 14.8076 6.61559 14.8076 7.30595C14.8076 7.9963 14.248 8.55595 13.5576 8.55595C12.8673 8.55595 12.3076 7.9963 12.3076 7.30595Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6583 1.14874C10.9642 0.918978 8.25588 0.905644 5.55956 1.10886L5.36633 1.12343C2.79502 1.31723 0.807617 3.46006 0.807617 6.03865V14.5559C0.807617 14.8198 0.946283 15.0643 1.17277 15.1997C1.39925 15.3351 1.68022 15.3415 1.91266 15.2166L5.82345 13.1149C6.00536 13.0171 6.20866 12.9659 6.41518 12.9659H15.3916C16.5237 12.9659 17.4939 12.1566 17.6968 11.0428C18.1081 8.78557 18.1406 6.4756 17.7929 4.2077L17.6905 3.53937C17.504 2.32262 16.5086 1.39181 15.2821 1.28721L13.6583 1.14874ZM5.67229 2.60462C8.28865 2.40743 10.9166 2.42037 13.5309 2.64331L15.1546 2.78178C15.691 2.82752 16.1262 3.23456 16.2078 3.76664L16.3102 4.43496C16.6326 6.53825 16.6025 8.68054 16.2211 10.7739C16.1481 11.1747 15.799 11.4659 15.3916 11.4659H6.41518C5.96084 11.4659 5.51358 11.5785 5.11337 11.7936L2.30762 13.3014V6.03865C2.30762 4.24475 3.69023 2.75401 5.47906 2.61919L5.67229 2.60462Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconEdit = createIcon({
  displayName: "editIcon",
  viewBox: "0 0 20 20",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="20" width="20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4546 3.91575C19.6468 4.20687 19.6147 4.60248 19.3585 4.85876L10.1661 14.0511C10.0718 14.1454 9.9542 14.2128 9.82528 14.2465L5.99685 15.2465C5.87198 15.2791 5.74327 15.2784 5.62234 15.2476C5.49378 15.2149 5.37401 15.1482 5.27699 15.0511C5.08871 14.8629 5.01438 14.5889 5.08167 14.3313L6.08167 10.5028C6.11113 10.39 6.16643 10.2786 6.24291 10.1912L15.4694 0.96967C15.5501 0.888906 15.6474 0.82846 15.7533 0.791631C15.8318 0.764324 15.915 0.75 15.9997 0.75C16.1986 0.75 16.3894 0.829017 16.53 0.96967L19.3585 3.7981C19.3951 3.83471 19.4271 3.87416 19.4546 3.91575ZM17.7675 4.32843L15.9997 2.56066L7.48153 11.0788L6.85654 13.4716L9.24931 12.8466L17.7675 4.32843Z"
        fill="#8E8C8C"
      />
      <path
        d="M17.641 15.6603C17.9145 13.3227 18.0014 10.9688 17.902 8.62079C17.8973 8.50837 17.9395 8.39898 18.0191 8.31942L19.0024 7.33609C19.1233 7.21519 19.3299 7.29194 19.3412 7.46254C19.5262 10.2522 19.456 13.0545 19.1309 15.8346C18.8943 17.8571 17.27 19.4421 15.258 19.667C11.7914 20.0544 8.20804 20.0544 4.74146 19.667C2.72941 19.4421 1.10507 17.8571 0.868521 15.8346C0.453983 12.2903 0.453983 8.70973 0.868521 5.16543C1.10507 3.1429 2.72941 1.55789 4.74146 1.33301C7.37121 1.0391 10.0682 0.968149 12.7303 1.12016C12.9019 1.12996 12.9801 1.33757 12.8586 1.45909L11.8661 2.45165C11.7874 2.53034 11.6795 2.57261 11.5682 2.56885C9.34181 2.49376 7.10025 2.57872 4.90807 2.82373C3.57797 2.97239 2.51248 4.022 2.35837 5.33968C1.95737 8.76821 1.95737 12.2318 2.35837 15.6603C2.51248 16.978 3.57797 18.0276 4.90807 18.1763C8.26392 18.5513 11.7355 18.5513 15.0913 18.1763C16.4214 18.0276 17.4869 16.978 17.641 15.6603Z"
        fill="#8E8C8C"
      />
    </g>
  ),
});

export const IconDownloadAll = createIcon({
  displayName: "downloadAllIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="25">
      <path
        d="M16.3321 7.77357C16.6189 8.07238 16.6092 8.54715 16.3104 8.83401L13.1854 11.834C12.8952 12.1126 12.4368 12.1126 12.1466 11.834L10.2716 10.034C9.97281 9.74715 9.96312 9.27238 10.25 8.97357C10.5368 8.67476 11.0116 8.66507 11.3104 8.95193L12.666 10.2533L15.2716 7.75193C15.5704 7.46507 16.0452 7.47476 16.3321 7.77357Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.54102 8.29297C4.54102 5.66962 6.66766 3.54297 9.29102 3.54297H19.291C20.2575 3.54297 21.041 4.32647 21.041 5.29297V20.293C21.041 21.2595 20.2575 22.043 19.291 22.043H8.29101C6.21995 22.043 4.54102 20.364 4.54102 18.293V8.29297ZM6.04102 15.2927C6.66776 14.8219 7.44681 14.543 8.29101 14.543H19.541V5.29297C19.541 5.1549 19.4291 5.04297 19.291 5.04297H9.29102C7.49609 5.04297 6.04102 6.49804 6.04102 8.29297V15.2927ZM6.04102 18.293C6.04102 19.5356 7.04837 20.543 8.29101 20.543H19.291C19.4291 20.543 19.541 20.431 19.541 20.293V16.043H8.29101C7.04837 16.043 6.04102 17.0503 6.04102 18.293Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconDownloadOrigin = createIcon({
  displayName: "downloadOriginIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="25">
      <path
        d="M16.541 13.293C16.541 12.8788 16.2052 12.543 15.791 12.543H9.79102C9.3768 12.543 9.04102 12.8788 9.04102 13.293C9.04102 13.7072 9.3768 14.043 9.79102 14.043H15.791C16.2052 14.043 16.541 13.7072 16.541 13.293Z"
        fill="#2F80ED"
      />
      <path
        d="M16.541 17.293C16.541 16.8788 16.2052 16.543 15.791 16.543H9.79102C9.3768 16.543 9.04102 16.8788 9.04102 17.293C9.04102 17.7072 9.3768 18.043 9.79102 18.043H15.791C16.2052 18.043 16.541 17.7072 16.541 17.293Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79102 2.54297C6.27223 2.54297 5.04102 3.77418 5.04102 5.29297V19.293C5.04102 20.8118 6.27223 22.043 7.79102 22.043H17.791C19.3098 22.043 20.541 20.8118 20.541 19.293V8.26063C20.541 7.87986 20.4168 7.50947 20.1873 7.20567L17.1895 3.23801C16.8588 2.80027 16.3419 2.54297 15.7932 2.54297H7.79102ZM6.54102 5.29297C6.54102 4.60261 7.10066 4.04297 7.79102 4.04297H15.041V8.44001C15.041 8.85423 15.3768 9.19001 15.791 9.19001H19.041V19.293C19.041 19.9833 18.4814 20.543 17.791 20.543H7.79102C7.10066 20.543 6.54102 19.9833 6.54102 19.293V5.29297Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconDownloadReceipt = createIcon({
  displayName: "downloadreceiptIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="25">
      <path
        d="M14.291 10.0432C14.291 9.62895 13.9552 9.29317 13.541 9.29317H7.54102C7.1268 9.29317 6.79102 9.62895 6.79102 10.0432C6.79102 10.4574 7.1268 10.7932 7.54102 10.7932H13.541C13.9552 10.7932 14.291 10.4574 14.291 10.0432Z"
        fill="#2F80ED"
      />
      <path
        d="M13.291 13.0432C13.291 12.629 12.9552 12.2932 12.541 12.2932H7.54102C7.1268 12.2932 6.79102 12.629 6.79102 13.0432C6.79102 13.4574 7.1268 13.7932 7.54102 13.7932H12.541C12.9552 13.7932 13.291 13.4574 13.291 13.0432Z"
        fill="#2F80ED"
      />
      <path
        d="M13.541 15.2932C13.9552 15.2932 14.291 15.629 14.291 16.0432C14.291 16.4574 13.9552 16.7932 13.541 16.7932H7.54102C7.1268 16.7932 6.79102 16.4574 6.79102 16.0432C6.79102 15.629 7.1268 15.2932 7.54102 15.2932H13.541Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.79102 22.0432H19.791C21.3098 22.0432 22.541 20.812 22.541 19.2932V13.7932C22.541 13.379 22.2052 13.0432 21.791 13.0432H18.541V5.23636C18.541 3.81296 16.9321 2.98499 15.7738 3.81233L15.5988 3.93736C14.8183 4.49486 13.7611 4.49298 12.9769 3.93287C11.6731 3.00154 9.90895 3.00154 8.60509 3.93287C7.82093 4.49298 6.76372 4.49486 5.98323 3.93736L5.80818 3.81233C4.64991 2.98499 3.04102 3.81296 3.04102 5.23636V18.2932C3.04102 20.3642 4.71995 22.0432 6.79102 22.0432ZM9.47694 5.15347C10.2593 4.59468 11.3228 4.59468 12.1051 5.15347C13.4071 6.0835 15.165 6.0906 16.4707 5.15796L16.6457 5.03293C16.8112 4.91474 17.041 5.03302 17.041 5.23636V19.2932C17.041 19.7433 17.1492 20.1681 17.3409 20.5432H6.79102C5.54838 20.5432 4.54102 19.5358 4.54102 18.2932V5.23636C4.54102 5.03302 4.77086 4.91474 4.93633 5.03293L5.11137 5.15796C6.41707 6.0906 8.17491 6.0835 9.47694 5.15347ZM18.541 19.2932V14.5432H21.041V19.2932C21.041 19.9835 20.4814 20.5432 19.791 20.5432C19.1007 20.5432 18.541 19.9835 18.541 19.2932Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconUpload = createIcon({
  displayName: "uploadIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="25">
      <path
        d="M15.8765 12.7612C15.6177 13.0846 15.1457 13.1371 14.8223 12.8783L13.5408 11.8532V15.2927C13.5408 15.7069 13.205 16.0427 12.7908 16.0427C12.3766 16.0427 12.0408 15.7069 12.0408 15.2927V11.8531L10.7593 12.8783C10.4359 13.1371 9.96391 13.0846 9.70515 12.7612C9.4464 12.4377 9.49884 11.9658 9.82228 11.707L12.3196 9.70914C12.4469 9.60625 12.6085 9.54414 12.7845 9.54269C12.7866 9.54267 12.7887 9.54266 12.7908 9.54266L12.7933 9.54267C12.9724 9.54323 13.1367 9.60658 13.2654 9.71186L15.7593 11.707C16.0828 11.9658 16.1352 12.4377 15.8765 12.7612Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.17086 7.48669C10.1326 5.99239 11.8113 5.00098 13.7227 5.00098C16.6032 5.00098 18.9579 7.25242 19.123 10.0916C19.1864 10.0889 19.2501 10.0875 19.3141 10.0875C21.787 10.0875 23.7917 12.0922 23.7917 14.5651C23.7917 17.038 21.787 19.0427 19.3141 19.0427H7.66544C4.42055 19.0427 1.79004 16.4122 1.79004 13.1673C1.79004 9.92236 4.42055 7.29186 7.66544 7.29186C8.1851 7.29186 8.68982 7.3595 9.17086 7.48669ZM13.7227 6.50098C12.1724 6.50098 10.8314 7.40331 10.199 8.71478C10.0289 9.06739 9.61627 9.22991 9.25144 9.08794C8.7607 8.89699 8.22624 8.79186 7.66544 8.79186C5.24897 8.79186 3.29004 10.7508 3.29004 13.1673C3.29004 15.5837 5.24897 17.5427 7.66544 17.5427H19.3141C20.9585 17.5427 22.2917 16.2096 22.2917 14.5651C22.2917 12.9206 20.9585 11.5875 19.3141 11.5875C19.0465 11.5875 18.7883 11.6226 18.5432 11.6881C18.303 11.7522 18.0466 11.6932 17.8587 11.5304C17.6708 11.3676 17.5757 11.1223 17.6049 10.8754C17.6229 10.7232 17.6322 10.5681 17.6322 10.4104C17.6322 8.2513 15.8819 6.50098 13.7227 6.50098Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconDownload = createIcon({
  displayName: "downloadIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="25">
      <path
        d="M14.8225 13.9573C15.146 13.6986 15.6179 13.751 15.8767 14.0744C16.1355 14.3979 16.083 14.8699 15.7596 15.1286L13.2656 17.1238C13.1369 17.2291 12.9726 17.2924 12.7935 17.293L12.7911 17.293L12.7847 17.2929C12.6087 17.2915 12.4471 17.2294 12.3199 17.1265L9.82252 15.1286C9.49908 14.8699 9.44663 14.3979 9.70539 14.0744C9.96415 13.751 10.4361 13.6986 10.7596 13.9573L12.0411 14.9825V11.543C12.0411 11.1288 12.3769 10.793 12.7911 10.793C13.2053 10.793 13.5411 11.1288 13.5411 11.543V14.9825L14.8225 13.9573Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79102 3.04297C6.27223 3.04297 5.04102 4.27419 5.04102 5.79297V19.793C5.04102 21.3118 6.27223 22.543 7.79102 22.543H17.791C19.3098 22.543 20.541 21.3118 20.541 19.793V8.99087C20.541 8.62475 20.4262 8.26785 20.2127 7.97042L17.1995 3.77252C16.8708 3.31454 16.3416 3.04297 15.7779 3.04297H7.79102ZM6.54102 5.79297C6.54102 5.10261 7.10066 4.54297 7.79102 4.54297H15.041V8.94001C15.041 9.35423 15.3768 9.69001 15.791 9.69001H19.041V19.793C19.041 20.4833 18.4814 21.043 17.791 21.043H7.79102C7.10066 21.043 6.54102 20.4833 6.54102 19.793V5.79297Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconSendMsg = createIcon({
  displayName: "sendMsgIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.75 12.8945C21.75 13.1669 21.6023 13.4179 21.3642 13.5502L19.0819 14.8181C14.5705 17.3245 9.81474 19.3632 4.88879 20.9026L4.22371 21.1104C3.99598 21.1816 3.74798 21.1401 3.55575 20.9988C3.36352 20.8575 3.25 20.6331 3.25 20.3945L3.25 14.6445C3.25 14.2535 3.55041 13.9281 3.94019 13.8969L4.16752 13.8787C6.31898 13.7066 8.45387 13.3774 10.5552 12.8942C8.42436 12.4043 6.25902 12.0728 4.0769 11.9028L3.94175 11.8923C3.55131 11.8619 3.25 11.5362 3.25 11.1445L3.25 5.39454C3.25 5.15595 3.36352 4.93159 3.55575 4.79027C3.74798 4.64894 3.99598 4.60751 4.22371 4.67868L4.88878 4.88651C9.81474 6.42587 14.5705 8.46461 19.0819 10.971L21.3642 12.2389C21.6023 12.3712 21.75 12.6222 21.75 12.8945ZM19.4557 12.8945L18.3534 12.2822C14.0256 9.87786 9.46847 7.91254 4.75 6.41542L4.75 10.4541C7.68008 10.7184 10.5783 11.2647 13.4043 12.0857L13.7092 12.1743C14.0299 12.2675 14.2503 12.5614 14.25 12.8953C14.2497 13.2292 14.0287 13.5226 13.7078 13.6152L13.3173 13.7278C10.5188 14.5349 7.65003 15.0729 4.75 15.3346L4.75 19.3737C9.46846 17.8765 14.0256 15.9112 18.3534 13.5069L19.4557 12.8945Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconAdd = createIcon({
  displayName: "addIcon",
  viewBox: "0 0 22 23",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="23" width="22" fill="none">
      <path
        d="M11 15.4864V8.1748"
        stroke="black"
        strokeWidth="0.77417"
        strokeLinecap="round"
      />
      <path
        d="M7.34465 11.8301L14.6562 11.8301"
        stroke="black"
        strokeWidth="0.77417"
        strokeLinecap="round"
      />
      <rect
        x="0.549194"
        y="1.37927"
        width="20.9026"
        height="20.9026"
        rx="10.4513"
        stroke="black"
        strokeWidth="0.77417"
      />
    </g>
  ),
});

export const IconPencil = createIcon({
  displayName: "pencilIcon",
  viewBox: "0 0 24 24",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1369 3.76264C14.9963 3.62199 14.8055 3.54297 14.6066 3.54297C14.4077 3.54297 14.2169 3.62199 14.0763 3.76264L4.88388 12.955C4.78965 13.0493 4.72223 13.1669 4.68856 13.2958L3.68856 17.1242C3.62127 17.3819 3.69561 17.6558 3.88388 17.8441C4.07215 18.0324 4.34614 18.1067 4.60375 18.0394L8.43218 17.0394C8.56111 17.0058 8.67874 16.9383 8.77297 16.8441L17.9654 7.65173C18.2582 7.35883 18.2582 6.88396 17.9654 6.59107L15.1369 3.76264ZM6.08843 13.8718L14.6066 5.35363L16.3744 7.1214L7.8562 15.6396L5.46344 16.2646L6.08843 13.8718Z"
        fill="black"
      />
      <path
        d="M4 19.543C3.58579 19.543 3.25 19.8788 3.25 20.293C3.25 20.7072 3.58579 21.043 4 21.043H19C19.4142 21.043 19.75 20.7072 19.75 20.293C19.75 19.8788 19.4142 19.543 19 19.543H4Z"
        fill="black"
      />
    </g>
  ),
});

export const IconDelete = createIcon({
  displayName: "deleteIcon",
  viewBox: "0 0 24 24",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" fill="none">
      <path
        fill="white"
        stroke="black"
        strokeWidth="2"
        d="M6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z"
      />
      <path
        fill="white"
        stroke="black"
        strokeWidth="2"
        d="M19 4H15.5L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H5V6H19V4Z"
      />
    </g>
  ),
});

export const IconBlueMark = createIcon({
  displayName: "blueMarkIcon",
  viewBox: "0 0 10 10",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="9" width="11" fill="none">
      <path
        d="M10.2325 0.791016H8.97624C8.70303 0.791016 8.44321 0.922265 8.28249 1.14727L4.07177 6.98655L2.16463 4.34012C2.00391 4.1178 1.74677 3.98387 1.47088 3.98387H0.214625C0.0405179 3.98387 -0.061268 4.18209 0.0405179 4.32405L3.37802 8.95262C3.45687 9.06267 3.5608 9.15234 3.68122 9.21419C3.80164 9.27605 3.93506 9.30832 4.07044 9.30832C4.20581 9.30832 4.33923 9.27605 4.45965 9.21419C4.58007 9.15234 4.684 9.06267 4.76285 8.95262L10.4039 1.13119C10.5084 0.98923 10.4066 0.791016 10.2325 0.791016Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconFileUpload = createIcon({
  displayName: "fileUploadIcon",
  viewBox: "0 0 42 42",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="42" width="42" fill="none">
      <rect y="0.109253" width="42" height="42" rx="21" fill="#2F80ED" />
      <path
        d="M21 28.1926V14.0259"
        stroke="white"
        strokeWidth="2.125"
        strokeLinecap="round"
      />
      <path
        d="M13.9167 21.1093L28.0834 21.1093"
        stroke="white"
        strokeWidth="2.125"
        strokeLinecap="round"
      />
    </g>
  ),
});

export const IconArrowSingleRight = createIcon({
  displayName: "arrowSingleRightIcon",
  viewBox: "0 0 24 24",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="none">
      <path
        d="M13.4697 8.53033C13.1768 8.23744 13.1768 7.76256 13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967L18.5303 11.4697C18.8232 11.7626 18.8232 12.2374 18.5303 12.5303L14.5303 16.5303C14.2374 16.8232 13.7626 16.8232 13.4697 16.5303C13.1768 16.2374 13.1768 15.7626 13.4697 15.4697L16.1893 12.75H6.5C6.08579 12.75 5.75 12.4142 5.75 12C5.75 11.5858 6.08579 11.25 6.5 11.25H16.1893L13.4697 8.53033Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconOrderPages = createIcon({
  displayName: "orderPagesIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24" fill="none">
      <path
        d="M15.75 13.7278C15.75 13.3136 15.4142 12.9778 15 12.9778H9C8.58579 12.9778 8.25 13.3136 8.25 13.7278C8.25 14.142 8.58579 14.4778 9 14.4778H15C15.4142 14.4778 15.75 14.142 15.75 13.7278Z"
        fill="black"
      />
      <path
        d="M15.75 17.7278C15.75 17.3136 15.4142 16.9778 15 16.9778H9C8.58579 16.9778 8.25 17.3136 8.25 17.7278C8.25 18.142 8.58579 18.4778 9 18.4778H15C15.4142 18.4778 15.75 18.142 15.75 17.7278Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.97778C5.48122 2.97778 4.25 4.209 4.25 5.72778V19.7278C4.25 21.2466 5.48122 22.4778 7 22.4778H17C18.5188 22.4778 19.75 21.2466 19.75 19.7278V8.69544C19.75 8.31467 19.6258 7.94429 19.3963 7.64048L16.3985 3.67282C16.0677 3.23508 15.5509 2.97778 15.0022 2.97778H7ZM5.75 5.72778C5.75 5.03743 6.30964 4.47778 7 4.47778H14.25V8.87483C14.25 9.28904 14.5858 9.62483 15 9.62483H18.25V19.7278C18.25 20.4181 17.6904 20.9778 17 20.9778H7C6.30964 20.9778 5.75 20.4181 5.75 19.7278V5.72778Z"
        fill="black"
      />
    </g>
  ),
});

export const IconLanguages = createIcon({
  displayName: "orderPagesIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6023 19.1741C11.7302 19.2509 11.8671 19.2849 12 19.2832C12.1329 19.2849 12.2698 19.2509 12.3977 19.1741L13.533 18.493C15.7595 17.1571 18.4825 16.9389 20.8933 17.9032C21.7826 18.2589 22.75 17.604 22.75 16.6461V4.98727C22.75 4.40932 22.3981 3.88959 21.8615 3.67495C18.7564 2.43291 15.2492 2.71394 12.3815 4.43456L12 4.66347L11.6185 4.43456C8.75077 2.71394 5.24357 2.43291 2.13848 3.67495C1.60187 3.88959 1.25 4.40932 1.25 4.98727V16.6461C1.25 17.604 2.21739 18.2589 3.10672 17.9032C5.51752 16.9389 8.24052 17.1571 10.467 18.493L11.6023 19.1741ZM2.75 5.04609V16.4329C5.54579 15.3848 8.67179 15.6665 11.2388 17.2067L11.25 17.2135V5.96276L10.8467 5.72079C8.39774 4.2514 5.40634 4.00307 2.75 5.04609ZM12.7612 17.2067L12.75 17.2135V5.96276L13.1533 5.72079C15.6023 4.2514 18.5937 4.00307 21.25 5.04609V16.4329C18.4542 15.3848 15.3282 15.6665 12.7612 17.2067Z"
        fill="black"
      />
      <path
        d="M9.27516 19.5804C7.2513 18.3998 4.7487 18.3998 2.72484 19.5804L2.6221 19.6403C2.26431 19.849 2.14346 20.3082 2.35217 20.666C2.56088 21.0238 3.02011 21.1447 3.3779 20.936L3.48065 20.876C5.03746 19.9679 6.96254 19.9679 8.51935 20.876L9.60661 21.5103C11.0856 22.373 12.9144 22.373 14.3934 21.5103L15.4806 20.876C17.0375 19.9679 18.9625 19.9679 20.5194 20.876L20.6221 20.936C20.9799 21.1447 21.4391 21.0238 21.6478 20.666C21.8565 20.3082 21.7357 19.849 21.3779 19.6403L21.2752 19.5804C19.2513 18.3998 16.7487 18.3998 14.7248 19.5804L13.6376 20.2146C12.6257 20.8049 11.3743 20.8049 10.3624 20.2146L9.27516 19.5804Z"
        fill="black"
      />
    </g>
  ),
});

export const IconCalendar = createIcon({
  displayName: "calendarIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99982 3.78809C7.41403 3.78809 7.74982 4.12387 7.74982 4.53809V6.20571C10.5776 5.95389 13.4221 5.95389 16.2498 6.20572V4.53809C16.2498 4.12387 16.5856 3.78809 16.9998 3.78809C17.414 3.78809 17.7498 4.12387 17.7498 4.53809V6.35452C19.2429 6.56563 20.4224 7.74655 20.6221 9.25292L20.7086 9.90587C21.0726 12.6522 21.0412 15.4365 20.6152 18.1739C20.4042 19.53 19.3026 20.5715 17.9368 20.7062L16.7438 20.8239C13.5888 21.135 10.4108 21.135 7.25574 20.8239L6.06274 20.7062C4.697 20.5715 3.59534 19.53 3.38433 18.1739C2.95837 15.4365 2.92693 12.6522 3.29097 9.90588L3.37752 9.25292C3.57719 7.74654 4.75674 6.5656 6.24982 6.35451V4.53809C6.24982 4.12387 6.5856 3.78809 6.99982 3.78809ZM7.44498 7.74089C10.4742 7.44216 13.5254 7.44216 16.5546 7.74089L17.46 7.83018C18.3268 7.91566 19.0206 8.58663 19.1351 9.45003L19.2216 10.103C19.2519 10.3311 19.2792 10.5595 19.3037 10.7881H4.69588C4.72036 10.5595 4.74772 10.3311 4.77796 10.103L4.86451 9.45003C4.97896 8.58663 5.67278 7.91566 6.53953 7.83018L7.44498 7.74089ZM4.57665 12.2881C4.47847 14.1762 4.5752 16.0713 4.86649 17.9433C4.97233 18.6235 5.52491 19.1459 6.20995 19.2135L7.40295 19.3311C10.4601 19.6326 13.5395 19.6326 16.5966 19.3311L17.7896 19.2135C18.4747 19.1459 19.0272 18.6235 19.1331 17.9433C19.4244 16.0713 19.5211 14.1762 19.4229 12.2881H4.57665Z"
        fill="black"
      />
    </g>
  ),
});

export const IconCheckedCircle = createIcon({
  displayName: "circleCheckedIcon",
  viewBox: "0 0 15 15",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="15" width="15" fill="none">
      <path
        d="M10.4074 4.54456H9.6719C9.51194 4.54456 9.35982 4.6214 9.26572 4.75313L6.80044 8.17191L5.68385 6.62248C5.58975 6.49232 5.4392 6.4139 5.27767 6.4139H4.54216C4.44023 6.4139 4.38063 6.52995 4.44023 6.61307L6.39426 9.323C6.44042 9.38743 6.50128 9.43992 6.57178 9.47614C6.64228 9.51236 6.72039 9.53125 6.79965 9.53125C6.87891 9.53125 6.95703 9.51236 7.02753 9.47614C7.09803 9.43992 7.15888 9.38743 7.20505 9.323L10.5078 4.74372C10.5689 4.66061 10.5093 4.54456 10.4074 4.54456Z"
        fill="#2F80ED"
      />
      <path
        d="M7.47447 0.0123291C3.59463 0.0123291 0.44873 3.15823 0.44873 7.03806C0.44873 10.9179 3.59463 14.0638 7.47447 14.0638C11.3543 14.0638 14.5002 10.9179 14.5002 7.03806C14.5002 3.15823 11.3543 0.0123291 7.47447 0.0123291ZM7.47447 12.8719C4.25329 12.8719 1.6406 10.2592 1.6406 7.03806C1.6406 3.81689 4.25329 1.2042 7.47447 1.2042C10.6956 1.2042 13.3083 3.81689 13.3083 7.03806C13.3083 10.2592 10.6956 12.8719 7.47447 12.8719Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconCheckedCircleFill = createIcon({
  displayName: "fillCircleCheckedIcon",
  viewBox: "0 0 17 17",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="17" width="17" fill="none">
      <rect x="0.5" width="17" height="17" rx="8.5" fill="#2F80ED" />
      <path
        d="M11.9328 6.00671H11.1973C11.0373 6.00671 10.8852 6.08356 10.7911 6.21529L8.32583 9.63406L7.20924 8.08464C7.11514 7.95447 6.96459 7.87606 6.80306 7.87606H6.06755C5.96562 7.87606 5.90602 7.99211 5.96562 8.07523L7.91965 10.7852C7.96581 10.8496 8.02667 10.9021 8.09717 10.9383C8.16767 10.9745 8.24579 10.9934 8.32504 10.9934C8.4043 10.9934 8.48242 10.9745 8.55292 10.9383C8.62342 10.9021 8.68427 10.8496 8.73044 10.7852L12.0332 6.20588C12.0943 6.12276 12.0347 6.00671 11.9328 6.00671V6.00671Z"
        fill="white"
      />
    </g>
  ),
});

export const IconArrowBack = createIcon({
  displayName: "arrowBackIcon",
  viewBox: "0 0 24 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24" fill="none">
      <path
        d="M11.0303 9.39581C11.3232 9.10292 11.3232 8.62804 11.0303 8.33515C10.7374 8.04226 10.2626 8.04226 9.96967 8.33515L5.96967 12.3351C5.82322 12.4816 5.75 12.6735 5.75 12.8655C5.75 12.9672 5.77024 13.0641 5.80691 13.1526C5.84351 13.241 5.89776 13.3239 5.96967 13.3958L9.96967 17.3958C10.2626 17.6887 10.7374 17.6887 11.0303 17.3958C11.3232 17.1029 11.3232 16.628 11.0303 16.3351L8.31066 13.6155H18C18.4142 13.6155 18.75 13.2797 18.75 12.8655C18.75 12.4513 18.4142 12.1155 18 12.1155H8.31066L11.0303 9.39581Z"
        fill="#2F80ED"
      />
    </g>
  ),
});


export const IconInfo = createIcon({
  displayName: "infoIcon",
  viewBox: "0 0 25 25",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="25" width="24" fill="none">
      <path
        d="M12.5 11.25C12.9142 11.25 13.25 11.5858 13.25 12V17C13.25 17.4142 12.9142 17.75 12.5 17.75C12.0858 17.75 11.75 17.4142 11.75 17V12C11.75 11.5858 12.0858 11.25 12.5 11.25Z"
        fill="#CCCCCC"
      />
      <path
        d="M12.5 9.5C13.0523 9.5 13.5 9.05228 13.5 8.5C13.5 7.94772 13.0523 7.5 12.5 7.5C11.9477 7.5 11.5 7.94772 11.5 8.5C11.5 9.05228 11.9477 9.5 12.5 9.5Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 12.5C3.75 7.66751 7.66751 3.75 12.5 3.75C17.3325 3.75 21.25 7.66751 21.25 12.5C21.25 17.3325 17.3325 21.25 12.5 21.25C7.66751 21.25 3.75 17.3325 3.75 12.5ZM12.5 5.25C8.49594 5.25 5.25 8.49594 5.25 12.5C5.25 16.5041 8.49594 19.75 12.5 19.75C16.5041 19.75 19.75 16.5041 19.75 12.5C19.75 8.49594 16.5041 5.25 12.5 5.25Z"
        fill="#CCCCCC"
      />
    </g>
  ),
});

export const IconDayShipping = createIcon({
  displayName: "dayShippingIcon",
  viewBox: "0 0 24 24",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="none">
      <path
        d="M11.5 5V12C11.5 12.2652 11.6054 12.5196 11.7929 12.7071C11.9804 12.8946 12.2348 13 12.5 13H19.5V11H13.5V5H11.5Z"
        fill="#2F80ED"
      />
      <path
        d="M12.5 2.6602e-06C9.31846 0.00344374 6.26821 1.26883 4.01852 3.51852C1.76883 5.76821 0.503441 8.81846 0.5 12H2.5C2.4982 9.74302 3.25874 7.55158 4.65832 5.78095C6.05791 4.01032 8.0145 2.76429 10.2109 2.24486C12.4073 1.72544 14.7148 1.96306 16.7592 2.91922C18.8036 3.87537 20.4652 5.494 21.4746 7.51271C22.4839 9.53142 22.7819 11.8319 22.3201 14.0411C21.8584 16.2504 20.664 18.2389 18.9307 19.6844C17.1973 21.1298 15.0265 21.9475 12.7702 22.0048C10.514 22.0621 8.30451 21.3556 6.5 20L8.3 17.6L1.1 17.2L3.5 24L5.3 21.594C6.8208 22.7366 8.59142 23.5013 10.4659 23.825C12.3403 24.1487 14.2648 24.0221 16.0808 23.4558C17.8967 22.8895 19.5519 21.8995 20.9101 20.5677C22.2682 19.2358 23.2902 17.6002 23.8919 15.7957C24.4935 13.9912 24.6576 12.0695 24.3706 10.1891C24.0835 8.30867 23.3535 6.52345 22.2409 4.98064C21.1282 3.43784 19.6647 2.18164 17.971 1.31566C16.2774 0.449687 14.4022 -0.0012638 12.5 2.6602e-06Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconNotarized = createIcon({
  displayName: "notarizedIcon",
  viewBox: "0 0 24 24",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="none">
      <path
        d="M12 20H1V1H19V8"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 14.625V22L19 21L16 22V14.625"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 16C21.2091 16 23 14.2091 23 12C23 9.79086 21.2091 8 19 8C16.7909 8 15 9.79086 15 12C15 14.2091 16.7909 16 19 16Z"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6H14"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10H11"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14H11"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

export const IconPaypal = createIcon({
  displayName: "paypalIcon",
  viewBox: "0 0 70 20",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="20" width="70" fill="none">
      <g clipPath="url(#clip0_1098_3206)">
        <path
          d="M25.7142 4.83789H21.9087C21.6482 4.83789 21.4268 5.03365 21.3862 5.29965L19.847 15.3967C19.8164 15.5959 19.9655 15.7756 20.1609 15.7756H21.9777C22.2381 15.7756 22.4596 15.5798 22.5002 15.3132L22.9153 12.5899C22.9554 12.3233 23.1774 12.1276 23.4372 12.1276H24.642C27.1488 12.1276 28.5955 10.8724 28.9734 8.38513C29.1437 7.29695 28.9806 6.44195 28.4881 5.84316C27.9473 5.18565 26.988 4.83789 25.7142 4.83789ZM26.1533 8.52562C25.9452 9.93853 24.9018 9.93853 23.893 9.93853H23.3187L23.7216 7.29983C23.7455 7.14035 23.8791 7.02289 24.0349 7.02289H24.2981C24.9853 7.02289 25.6336 7.02289 25.9685 7.42822C26.1683 7.67004 26.2295 8.02932 26.1533 8.52562Z"
          fill="#253B80"
        />
        <path
          d="M37.0898 8.48007H35.2674C35.1121 8.48007 34.978 8.59752 34.9541 8.75701L34.8734 9.2844L34.746 9.09325C34.3515 8.5008 33.4717 8.30273 32.5936 8.30273C30.5798 8.30273 28.8598 9.88089 28.5249 12.0947C28.3507 13.199 28.5983 14.2549 29.2037 14.9913C29.7591 15.6684 30.5537 15.9505 31.4991 15.9505C33.1217 15.9505 34.0215 14.871 34.0215 14.871L33.9402 15.3949C33.9096 15.5953 34.0588 15.7749 34.253 15.7749H35.8945C36.1555 15.7749 36.3758 15.5792 36.417 15.3126L37.4019 8.85892C37.4331 8.66028 37.2845 8.48007 37.0898 8.48007ZM34.5496 12.1499C34.3737 13.2272 33.5474 13.9503 32.4935 13.9503C31.9643 13.9503 31.5414 13.7747 31.2698 13.4419C31.0005 13.1115 30.8981 12.6411 30.9838 12.1171C31.148 11.0491 31.9882 10.3023 33.026 10.3023C33.5435 10.3023 33.9642 10.4802 34.2413 10.8159C34.5189 11.155 34.6291 11.6283 34.5496 12.1499Z"
          fill="#253B80"
        />
        <path
          d="M46.7954 8.48022H44.9641C44.7894 8.48022 44.6252 8.57004 44.5262 8.72032L42.0004 12.5698L40.9298 8.87059C40.8625 8.63913 40.656 8.48022 40.4223 8.48022H38.6228C38.4041 8.48022 38.2522 8.70132 38.3217 8.91435L40.3389 15.0393L38.4425 17.8092C38.2933 18.0274 38.4436 18.3274 38.7012 18.3274H40.5303C40.7039 18.3274 40.8664 18.2399 40.9649 18.0925L47.0558 8.99553C47.2016 8.77789 47.0519 8.48022 46.7954 8.48022Z"
          fill="#253B80"
        />
        <path
          d="M52.8584 4.83789H49.0523C48.7924 4.83789 48.5709 5.03365 48.5303 5.29965L46.9912 15.3967C46.9606 15.5959 47.1097 15.7756 47.3039 15.7756H49.257C49.4385 15.7756 49.5937 15.6385 49.6221 15.452L50.0589 12.5899C50.099 12.3233 50.321 12.1276 50.5808 12.1276H51.785C54.2924 12.1276 55.7386 10.8724 56.117 8.38513C56.2878 7.29695 56.1237 6.44195 55.6312 5.84316C55.0909 5.18565 54.1321 4.83789 52.8584 4.83789ZM53.2974 8.52562C53.0899 9.93853 52.0465 9.93853 51.0371 9.93853H50.4634L50.8669 7.29983C50.8908 7.14035 51.0232 7.02289 51.1796 7.02289H51.4428C52.1295 7.02289 52.7783 7.02289 53.1133 7.42822C53.313 7.67004 53.3737 8.02932 53.2974 8.52562Z"
          fill="#179BD7"
        />
        <path
          d="M64.2335 8.48007H62.4122C62.2559 8.48007 62.1229 8.59752 62.0995 8.75701L62.0188 9.2844L61.8908 9.09325C61.4963 8.5008 60.6171 8.30273 59.739 8.30273C57.7252 8.30273 56.0058 9.88089 55.6708 12.0947C55.4972 13.199 55.7437 14.2549 56.3491 14.9913C56.9056 15.6684 57.6991 15.9505 58.6445 15.9505C60.2671 15.9505 61.1669 14.871 61.1669 14.871L61.0856 15.3949C61.055 15.5953 61.2042 15.7749 61.3995 15.7749H63.0405C63.3003 15.7749 63.5218 15.5792 63.5624 15.3126L64.5479 8.85892C64.5779 8.66028 64.4288 8.48007 64.2335 8.48007ZM61.6933 12.1499C61.5186 13.2272 60.6911 13.9503 59.6372 13.9503C59.1091 13.9503 58.6851 13.7747 58.4136 13.4419C58.1442 13.1115 58.043 12.6411 58.1276 12.1171C58.2928 11.0491 59.1319 10.3023 60.1697 10.3023C60.6872 10.3023 61.1079 10.4802 61.385 10.8159C61.6638 11.155 61.774 11.6283 61.6933 12.1499Z"
          fill="#179BD7"
        />
        <path
          d="M66.3819 5.11492L64.8199 15.3968C64.7893 15.596 64.9384 15.7756 65.1326 15.7756H66.7029C66.9639 15.7756 67.1854 15.5799 67.2255 15.3133L68.7657 5.21683C68.7963 5.01761 68.6472 4.8374 68.453 4.8374H66.6946C66.5394 4.83798 66.4058 4.95543 66.3819 5.11492Z"
          fill="#179BD7"
        />
        <path
          d="M4.04324 17.7378L4.33426 15.8251L3.68599 15.8096H0.590454L2.7417 1.69605C2.74837 1.65345 2.77008 1.61372 2.80179 1.58551C2.83351 1.55729 2.87413 1.54175 2.91642 1.54175H8.13594C9.86873 1.54175 11.0645 1.91484 11.6889 2.65123C11.9816 2.99669 12.168 3.35769 12.2581 3.75496C12.3527 4.17181 12.3544 4.66984 12.262 5.27726L12.2553 5.3216V5.71081L12.548 5.88238C12.7945 6.01769 12.9904 6.17257 13.1407 6.3499C13.3911 6.64526 13.553 7.02066 13.6214 7.46572C13.6921 7.92344 13.6687 8.46811 13.553 9.08475C13.4194 9.79408 13.2035 10.4119 12.912 10.9174C12.6438 11.3832 12.3021 11.7695 11.8964 12.0689C11.5091 12.3533 11.049 12.5692 10.5287 12.7074C10.0245 12.8433 9.44972 12.9118 8.81926 12.9118H8.41305C8.12258 12.9118 7.84046 13.0201 7.61899 13.2141C7.39697 13.4121 7.25007 13.6827 7.20499 13.9787L7.17439 14.1508L6.66023 17.5219L6.63686 17.6457C6.63074 17.6848 6.62016 17.7044 6.60458 17.7177C6.59067 17.7297 6.57064 17.7378 6.55116 17.7378H4.04324Z"
          fill="#253B80"
        />
        <path
          d="M12.8251 5.36646C12.8095 5.46952 12.7917 5.57488 12.7717 5.68312C12.0833 9.33976 9.72842 10.603 6.7208 10.603H5.18944C4.82163 10.603 4.51168 10.8793 4.45437 11.2547L3.67033 16.3997L3.4483 17.8581C3.41102 18.1045 3.59465 18.3268 3.83504 18.3268H6.55108C6.87271 18.3268 7.14592 18.0849 7.19656 17.7568L7.22327 17.614L7.73465 14.2562L7.76748 14.0719C7.81756 13.7426 8.09134 13.5008 8.41297 13.5008H8.81917C11.4506 13.5008 13.5106 12.3953 14.1127 9.19639C14.3642 7.86006 14.234 6.74424 13.5685 5.95949C13.3671 5.72285 13.1172 5.52652 12.8251 5.36646Z"
          fill="#179BD7"
        />
        <path
          d="M12.105 5.06936C11.9998 5.03769 11.8913 5.0089 11.78 4.98299C11.6682 4.95766 11.5536 4.93521 11.4356 4.91563C11.0227 4.84654 10.5703 4.81372 10.0856 4.81372H5.9946C5.89389 4.81372 5.79818 4.83733 5.71248 4.87993C5.52385 4.97378 5.38362 5.1586 5.34968 5.38487L4.47939 11.0883L4.45435 11.2547C4.51166 10.8793 4.8216 10.603 5.18942 10.603H6.72077C9.72839 10.603 12.0833 9.33918 12.7716 5.68311C12.7922 5.57487 12.8095 5.46951 12.825 5.36645C12.6509 5.27087 12.4622 5.18911 12.2591 5.11945C12.2091 5.10218 12.1573 5.08548 12.105 5.06936Z"
          fill="#222D65"
        />
        <path
          d="M5.34972 5.38491C5.38366 5.15863 5.52389 4.97382 5.71253 4.88054C5.79878 4.83794 5.89393 4.81433 5.99465 4.81433H10.0857C10.5703 4.81433 11.0227 4.84715 11.4356 4.91624C11.5536 4.93582 11.6682 4.95827 11.7801 4.9836C11.8914 5.00951 11.9999 5.0383 12.105 5.06997C12.1573 5.08609 12.2091 5.10279 12.2597 5.11948C12.4628 5.18915 12.6515 5.27148 12.8256 5.36648C13.0304 4.01518 12.824 3.09512 12.1178 2.262C11.3394 1.34482 9.93432 0.952148 8.13643 0.952148H2.91691C2.54966 0.952148 2.23637 1.22851 2.17961 1.60448L0.0055583 15.8631C-0.0372885 16.1452 0.17305 16.3997 0.447937 16.3997H3.67035L4.47943 11.0884L5.34972 5.38491Z"
          fill="#253B80"
        />
      </g>
      <defs>
        <clipPath id="clip0_1098_3206">
          <rect
            width="69"
            height="19"
            fill="white"
            transform="translate(0 0.952148)"
          />
        </clipPath>
      </defs>
    </g>
  ),
});

export const IconCardVisa = createIcon({
  displayName: "visaCardIcon",
  viewBox: "0 0 33 22",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="22" width="33" fill="none">
      <rect y="0.5" width="33" height="22" rx="4" fill="#00579F" />
      <path
        d="M14.1185 15.2424H12.2526L13.4196 8.22656H15.2854L14.1185 15.2424Z"
        fill="white"
      />
      <path
        d="M20.8817 8.3983C20.5137 8.25635 19.9299 8.09961 19.2082 8.09961C17.3655 8.09961 16.068 9.0549 16.06 10.4207C16.0447 11.4284 16.989 11.988 17.6953 12.324C18.4172 12.6674 18.6626 12.8915 18.6626 13.1975C18.6552 13.6675 18.0793 13.8841 17.542 13.8841C16.7971 13.8841 16.3979 13.7724 15.7913 13.511L15.5457 13.3989L15.2845 14.9738C15.7222 15.1676 16.5284 15.3396 17.3655 15.3471C19.3234 15.3471 20.598 14.4066 20.6131 12.9512C20.6205 12.1525 20.1219 11.5405 19.0468 11.0405C18.3942 10.7195 17.9946 10.503 17.9946 10.1746C18.0022 9.87598 18.3326 9.57015 19.0693 9.57015C19.6759 9.55517 20.1216 9.69692 20.4592 9.83878L20.628 9.91328L20.8817 8.3983Z"
        fill="white"
      />
      <path
        d="M23.3627 12.7569C23.5163 12.3539 24.1076 10.7939 24.1076 10.7939C24.0999 10.8089 24.261 10.3835 24.3531 10.1223L24.4835 10.7268C24.4835 10.7268 24.8369 12.4061 24.9136 12.7569C24.622 12.7569 23.7312 12.7569 23.3627 12.7569ZM25.6659 8.22656H24.2226C23.7775 8.22656 23.4394 8.35334 23.2474 8.80867L20.4758 15.2423H22.4337C22.4337 15.2423 22.756 14.3763 22.8253 14.1899C23.04 14.1899 24.9446 14.1899 25.2209 14.1899C25.2745 14.4362 25.4436 15.2423 25.4436 15.2423H27.1712L25.6659 8.22656Z"
        fill="white"
      />
      <path
        d="M10.6939 8.22656L8.86656 13.0107L8.66688 12.0404C8.32905 10.9208 7.26953 9.70444 6.08716 9.09962L7.76092 15.2349H9.73406L12.6669 8.22656H10.6939Z"
        fill="white"
      />
      <path
        d="M7.16972 8.22656H4.16767L4.13696 8.36832C6.47874 8.95052 8.02966 10.3539 8.66686 12.0407L8.01425 8.8163C7.90681 8.36822 7.57663 8.24134 7.16972 8.22656Z"
        fill="#FAA61A"
      />
    </g>
  ),
});

export const IconCardExpress = createIcon({
  displayName: "expressCardIcon",
  viewBox: "0 0 33 22",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="22" width="33" fill="none">
      <mask
        id="mask0_337_7648"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="33"
        height="23"
      >
        <rect y="0.5" width="33" height="22" fill="#016FD0" />
      </mask>
      <g mask="url(#mask0_337_7648)">
        <rect y="0.5" width="33" height="22" rx="4" fill="#016FD0" />
        <path
          d="M6.41895 17.3306V12.2832H11.9159L12.5057 13.0307L13.1149 12.2832H33.0676V16.9825C33.0676 16.9825 32.5458 17.3256 31.9423 17.3306H20.8941L20.2292 16.535V17.3306H18.0502V15.9724C18.0502 15.9724 17.7526 16.162 17.1091 16.162H16.3674V17.3306H13.0683L12.4794 16.5671L11.8814 17.3306H6.41895Z"
          fill="white"
        />
        <path
          d="M0 8.47907L1.23959 5.66943H3.38332L4.0868 7.24328V5.66943H6.75167L7.17045 6.80696L7.57644 5.66943H19.5389V6.24131C19.5389 6.24131 20.1678 5.66943 21.2013 5.66943L25.0826 5.68262L25.774 7.23587V5.66943H28.0041L28.6179 6.56165V5.66943H30.8684V10.7168H28.6179L28.0296 9.82173V10.7168H24.7531L24.4236 9.92119H23.5428L23.2187 10.7168H20.9967C20.1074 10.7168 19.5389 10.1566 19.5389 10.1566V10.7168H16.1887L15.5237 9.92119V10.7168H3.06574L2.73647 9.92119H1.85844L1.5315 10.7168H0V8.47907Z"
          fill="white"
        />
        <path
          d="M1.67743 6.2915L0.00549316 10.0708H1.09401L1.4025 9.31405H3.19591L3.5028 10.0708H4.61529L2.94496 6.2915H1.67743ZM2.29601 7.17107L2.84266 8.49353H1.74775L2.29601 7.17107Z"
          fill="#016FD0"
        />
        <path
          d="M4.73047 10.0699V6.29053L6.27731 6.29611L7.177 8.73279L8.05515 6.29053H9.58962V10.0699H8.61779V7.28509L7.58763 10.0699H6.73533L5.7023 7.28509V10.0699H4.73047Z"
          fill="#016FD0"
        />
        <path
          d="M10.2554 10.0699V6.29053H13.4266V7.13592H11.2374V7.78239H13.3755V8.57805H11.2374V9.24938H13.4266V10.0699H10.2554Z"
          fill="#016FD0"
        />
        <path
          d="M13.9884 6.2915V10.0709H14.9602V8.72821H15.3694L16.5347 10.0709H17.7223L16.4436 8.67848C16.9684 8.63542 17.5097 8.19751 17.5097 7.51763C17.5097 6.72232 16.8677 6.2915 16.1511 6.2915H13.9884ZM14.9602 7.13689H16.0711C16.3376 7.13689 16.5315 7.33956 16.5315 7.53472C16.5315 7.7858 16.2803 7.93255 16.0855 7.93255H14.9602V7.13689Z"
          fill="#016FD0"
        />
        <path
          d="M18.9001 10.0699H17.9078V6.29053H18.9001V10.0699Z"
          fill="#016FD0"
        />
        <path
          d="M21.2528 10.0699H21.0386C20.0023 10.0699 19.373 9.27611 19.373 8.19576C19.373 7.08871 19.9952 6.29053 21.3039 6.29053H22.3781V7.18564H21.2647C20.7334 7.18564 20.3577 7.58873 20.3577 8.20508C20.3577 8.937 20.7873 9.24441 21.4062 9.24441H21.662L21.2528 10.0699Z"
          fill="#016FD0"
        />
        <path
          d="M23.3682 6.2915L21.6963 10.0708H22.7848L23.0933 9.31405H24.8867L25.1936 10.0708H26.3061L24.6358 6.2915H23.3682ZM23.9868 7.17107L24.5335 8.49353H23.4386L23.9868 7.17107Z"
          fill="#016FD0"
        />
        <path
          d="M26.4185 10.0699V6.29053H27.654L29.2317 8.66507V6.29053H30.2035V10.0699H29.0079L27.3903 7.6332V10.0699H26.4185Z"
          fill="#016FD0"
        />
        <path
          d="M7.08411 16.6842V12.9048H10.2554V13.7502H8.06618V14.3966H10.2042V15.1923H8.06618V15.8636H10.2554V16.6842H7.08411Z"
          fill="#016FD0"
        />
        <path
          d="M22.6226 16.6842V12.9048H25.7938V13.7502H23.6046V14.3966H25.7324V15.1923H23.6046V15.8636H25.7938V16.6842H22.6226Z"
          fill="#016FD0"
        />
        <path
          d="M10.3788 16.6841L11.9229 14.8178L10.342 12.9048H11.5664L12.5079 14.0874L13.4525 12.9048H14.629L13.0689 14.7945L14.6158 16.6841H13.3916L12.4775 15.5202L11.5856 16.6841H10.3788Z"
          fill="#016FD0"
        />
        <path
          d="M14.7302 12.9053V16.6846H15.7276V15.4912H16.7506C17.6162 15.4912 18.2723 15.0447 18.2723 14.1765C18.2723 13.4572 17.7577 12.9053 16.8769 12.9053H14.7302ZM15.7276 13.76H16.805C17.0846 13.76 17.2845 13.9266 17.2845 14.1951C17.2845 14.4473 17.0856 14.6302 16.8018 14.6302H15.7276V13.76Z"
          fill="#016FD0"
        />
        <path
          d="M18.6948 12.9048V16.6842H19.6667V15.3415H20.0759L21.2411 16.6842H22.4287L21.15 15.2918C21.6748 15.2487 22.2161 14.8108 22.2161 14.1309C22.2161 13.3356 21.5741 12.9048 20.8575 12.9048H18.6948ZM19.6667 13.7502H20.7776C21.0441 13.7502 21.2379 13.9528 21.2379 14.148C21.2379 14.3991 20.9867 14.5458 20.792 14.5458H19.6667V13.7502Z"
          fill="#016FD0"
        />
        <path
          d="M26.2447 16.6842V15.8636H28.1897C28.4775 15.8636 28.6021 15.7124 28.6021 15.5466C28.6021 15.3877 28.4779 15.2271 28.1897 15.2271H27.3108C26.5468 15.2271 26.1213 14.7746 26.1213 14.0952C26.1213 13.4892 26.511 12.9048 27.6462 12.9048H29.5388L29.1296 13.7551H27.4928C27.1799 13.7551 27.0836 13.9148 27.0836 14.0672C27.0836 14.2239 27.2026 14.3966 27.4416 14.3966H28.3623C29.214 14.3966 29.5835 14.8663 29.5835 15.4814C29.5835 16.1426 29.1717 16.6842 28.316 16.6842H26.2447Z"
          fill="#016FD0"
        />
        <path
          d="M29.8108 16.6842V15.8636H31.7557C32.0435 15.8636 32.1681 15.7124 32.1681 15.5466C32.1681 15.3877 32.0439 15.2271 31.7557 15.2271H30.8768C30.1129 15.2271 29.6874 14.7746 29.6874 14.0952C29.6874 13.4892 30.077 12.9048 31.2123 12.9048H33.0661L32.6956 13.7551H31.0588C30.7459 13.7551 30.6496 13.9148 30.6496 14.0672C30.6496 14.2239 30.7686 14.3966 31.0077 14.3966H31.9284C32.78 14.3966 33.1496 14.8663 33.1496 15.4813C33.1496 16.1426 32.7378 16.6842 31.882 16.6842H29.8108Z"
          fill="#016FD0"
        />
      </g>
    </g>
  ),
});

export const IconCardDiscover = createIcon({
  displayName: "discoverCardIcon",
  viewBox: "0 0 33 22",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="22" width="33" fill="none">
      <rect y="0.5" width="33" height="22" rx="4" fill="#232342" />
      <path
        d="M14.3788 22.5003L33.0002 17.2295V18.5003C33.0002 20.7095 31.2094 22.5003 29.0002 22.5003H14.3788Z"
        fill="#FD6020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4608 9.31011C29.4853 9.31011 30.0487 9.75336 30.0487 10.5906C30.1 11.2309 29.639 11.7726 29.0243 11.8711L30.4073 13.6933H29.3316L28.1535 11.9203H28.051V13.6933H27.1802V9.31011H28.4608ZM28.051 11.3293H28.3071C28.8706 11.3293 29.1267 11.0831 29.1267 10.6398C29.1267 10.2458 28.8706 9.9996 28.3071 9.9996H28.051V11.3293ZM24.1581 13.6933H26.6168V12.9546H25.0288V11.7726H26.5656V11.0338H25.0288V10.0489H26.6168V9.31011H24.1581V13.6933ZM21.5969 12.2651L20.4187 9.31011H19.4967L21.392 13.7918H21.853L23.7483 9.31011H22.8262L21.5969 12.2651ZM11.1985 11.5263C11.1985 12.7576 12.223 13.7918 13.5036 13.7918C13.9134 13.7918 14.2719 13.6933 14.6305 13.5456V12.5606C14.3744 12.8561 14.0158 13.0531 13.606 13.0531C12.7865 13.0531 12.1206 12.4621 12.1206 11.6741V11.5756C12.0693 10.7876 12.7352 10.0981 13.5548 10.0489C13.9646 10.0489 14.3744 10.2459 14.6305 10.5413V9.55635C14.3232 9.35936 13.9134 9.31011 13.5548 9.31011C12.223 9.21161 11.1985 10.2459 11.1985 11.5263ZM9.61062 10.9846C9.09838 10.7876 8.94471 10.6891 8.94471 10.4428C8.99594 10.1474 9.25205 9.9011 9.55939 9.95035C9.81551 9.95035 10.0716 10.0981 10.2765 10.2951L10.7375 9.7041C10.379 9.40861 9.91796 9.21161 9.45695 9.21161C8.73982 9.16236 8.12514 9.7041 8.07392 10.3936V10.4428C8.07392 11.0338 8.33003 11.3786 9.14961 11.6248C9.3545 11.6741 9.55939 11.7726 9.76429 11.8711C9.91796 11.9696 10.0204 12.1173 10.0204 12.3143C10.0204 12.6591 9.71307 12.9546 9.40572 12.9546H9.3545C8.94471 12.9546 8.58615 12.7083 8.43248 12.3636L7.86902 12.9053C8.17636 13.4471 8.79104 13.7426 9.40572 13.7426C10.2253 13.7918 10.8912 13.2008 10.9424 12.4128V12.2651C10.8912 11.6741 10.6351 11.3786 9.61062 10.9846ZM6.63966 13.6933H7.51046V9.31011H6.63966V13.6933ZM2.59302 9.31011H3.8736H4.12972C5.35908 9.35936 6.33232 10.3444 6.2811 11.5263C6.2811 12.1666 5.97376 12.7576 5.46153 13.2008C5.00052 13.5456 4.43706 13.7426 3.8736 13.6933H2.59302V9.31011ZM3.71993 12.9546C4.12971 13.0038 4.59072 12.8561 4.89807 12.6098C5.20541 12.3143 5.35908 11.9203 5.35908 11.4771C5.35908 11.0831 5.20541 10.6891 4.89807 10.3936C4.59072 10.1474 4.12971 9.99961 3.71993 10.0489H3.46381V12.9546H3.71993Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2432 9.2085C15.9627 9.2085 14.887 10.1935 14.887 11.474C14.887 12.7052 15.9114 13.7395 17.2432 13.7887C18.575 13.838 19.5995 12.8037 19.6507 11.5232C19.5995 10.2427 18.575 9.2085 17.2432 9.2085V9.2085Z"
        fill="#FD6020"
      />
    </g>
  ),
});

export const IconCardMaster = createIcon({
  displayName: "masterCardIcon",
  viewBox: "0 0 33 22",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="22" width="33" fill="none">
      <rect y="0.5" width="33" height="22" rx="4" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7358 16.2274C15.6123 17.1699 14.155 17.739 12.5625 17.739C9.00919 17.739 6.12866 14.9059 6.12866 11.4112C6.12866 7.91652 9.00919 5.0835 12.5625 5.0835C14.155 5.0835 15.6123 5.65252 16.7358 6.59511C17.8593 5.65252 19.3166 5.0835 20.9091 5.0835C24.4624 5.0835 27.3429 7.91652 27.3429 11.4112C27.3429 14.9059 24.4624 17.739 20.9091 17.739C19.3166 17.739 17.8593 17.1699 16.7358 16.2274Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7358 16.2274C18.1192 15.0667 18.9964 13.3397 18.9964 11.4112C18.9964 9.48273 18.1192 7.75573 16.7358 6.59511C17.8593 5.65252 19.3167 5.0835 20.9091 5.0835C24.4625 5.0835 27.343 7.91652 27.343 11.4112C27.343 14.9059 24.4625 17.739 20.9091 17.739C19.3167 17.739 17.8593 17.1699 16.7358 16.2274Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7359 16.2274C15.3525 15.0668 14.4753 13.3398 14.4753 11.4113C14.4753 9.48283 15.3525 7.75584 16.7359 6.59521C18.1192 7.75584 18.9964 9.48283 18.9964 11.4113C18.9964 13.3398 18.1192 15.0668 16.7359 16.2274Z"
        fill="#FF5E00"
      />
    </g>
  ),
});

export const IconUPS = createIcon({
  displayName: "upsIcon",
  viewBox: "0 0 29 33",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="33" width="29" fill="none">
      <g clipPath="url(#clip0_337_8058)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5127 10.2156L1.63154 23.2097L4.6621 26.816L13.7541 31.4526L24.9257 26.1863L27.2432 20.8627L27.0055 3.63233L18.5674 3.40335L9.77283 4.77718L1.75074 9.2421L1.5127 10.2156Z"
          fill="#301506"
        />
        <path
          d="M14.5298 0.825453C9.23388 0.825453 4.61438 1.81314 0.798828 3.7609V19.3326C0.798828 22.6092 2.07684 25.3491 4.49405 27.2579C6.73842 29.0314 13.6795 31.954 14.53 32.309C15.3367 31.9708 22.36 29.003 24.5687 27.2579C26.9846 25.3501 28.2629 22.6094 28.2629 19.3326V3.7609C24.4468 1.81288 19.8273 0.825195 14.5293 0.825195L14.5298 0.825453ZM22.3715 3.84057C23.9508 3.86046 25.5015 3.95444 27.0005 4.08863V19.3325C27.0005 22.2619 25.897 24.6282 23.768 26.3176C21.8659 27.8265 16.1304 30.3019 14.53 30.9815C12.9082 30.2927 7.15835 27.7861 5.2905 26.3182C3.17402 24.6578 2.05996 22.2353 2.05996 19.3331V10.4259C8.14211 5.05268 15.5277 3.75469 22.371 3.84091L22.3715 3.84057ZM14.8878 10.9387C13.5848 10.9387 12.5334 11.2193 11.6678 11.7575V26.7556H14.0577V21.9102C14.2962 21.978 14.6424 22.0413 15.1328 22.0413C17.7838 22.0413 19.3075 19.7392 19.3075 16.378C19.3075 13.0233 17.7386 10.9387 14.8879 10.9387L14.8878 10.9387ZM23.0538 10.9387C21.4821 10.9826 19.8384 12.0794 19.8484 13.9387C19.8525 15.163 20.2048 16.0785 22.1744 17.1918C23.2256 17.7862 23.6491 18.1779 23.6672 18.9001C23.6873 19.7029 23.1115 20.187 22.2352 20.1838C21.4727 20.1779 20.5613 19.7703 19.951 19.2469V21.3656C20.6993 21.7954 21.6331 22.0795 22.5764 22.0795C24.9373 22.0795 25.9916 20.473 26.0371 19.0008C26.082 17.6591 25.6971 16.6438 23.7007 15.5138C22.8096 15.0104 22.1059 14.6795 22.1294 13.8418C22.1529 13.0241 22.8576 12.7368 23.5342 12.7427C24.369 12.7498 25.1765 13.1951 25.6749 13.6876V11.6869C25.2549 11.3752 24.3655 10.8999 23.0537 10.9387L23.0538 10.9387ZM3.28036 11.1717V18.4061C3.28036 20.845 4.47798 22.0797 6.84159 22.0797C8.30414 22.0797 9.52909 21.7536 10.4416 21.156V11.1717H8.05695V19.8461C7.79701 20.0178 7.41143 20.1275 6.92638 20.1275C5.83167 20.1275 5.66809 19.1604 5.66809 18.508V11.1718H3.2803L3.28036 11.1717ZM14.9039 12.7922C16.29 12.7922 16.8646 13.8582 16.8646 16.4366C16.8646 18.9522 16.2075 20.1677 14.8327 20.1677C14.5091 20.1677 14.2279 20.0905 14.057 20.0285V12.9588C14.2506 12.8658 14.5796 12.7924 14.9039 12.7924V12.7922Z"
          fill="#FAB80A"
        />
      </g>
      <defs>
        <clipPath id="clip0_337_8058">
          <rect
            width="28"
            height="32"
            fill="white"
            transform="translate(0.557617 0.542969)"
          />
        </clipPath>
      </defs>
    </g>
  ),
});

export const IconPlus = createIcon({
  displayName: "plusIcon",
  viewBox: "0 0 24 24",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="none">
      <path
        d="M12.5 17V7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.5 12L17.5 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
});

export const IconAsana = createIcon({
  displayName: "asanaIcon",
  viewBox: "0 0 40 40",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="40" width="40" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0868 5.77603C17.8754 5.44938 18.7206 5.28125 19.5742 5.28125C20.4278 5.28125 21.273 5.44938 22.0617 5.77603C22.8503 6.10269 23.5668 6.58148 24.1704 7.18506C24.774 7.78864 25.2528 8.50519 25.5794 9.29381C25.9061 10.0824 26.0742 10.9277 26.0742 11.7812C26.0742 12.6348 25.9061 13.4801 25.5794 14.2687C25.2528 15.0573 24.774 15.7739 24.1704 16.3774C23.5668 16.981 22.8503 17.4598 22.0617 17.7865C21.273 18.1131 20.4278 18.2812 19.5742 18.2812C18.7206 18.2812 17.8754 18.1131 17.0868 17.7865C16.2982 17.4598 15.5816 16.981 14.978 16.3774C14.3744 15.7739 13.8957 15.0573 13.569 14.2687C13.2423 13.4801 13.0742 12.6348 13.0742 11.7812C13.0742 10.9277 13.2423 10.0824 13.569 9.29381C13.8957 8.50519 14.3744 7.78864 14.978 7.18506C15.5816 6.58148 16.2982 6.10269 17.0868 5.77603ZM19.5742 7.71875C19.0407 7.71875 18.5125 7.82383 18.0196 8.02799C17.5267 8.23215 17.0788 8.53139 16.7016 8.90863C16.3244 9.28587 16.0251 9.73371 15.821 10.2266C15.6168 10.7195 15.5117 11.2478 15.5117 11.7812C15.5117 12.3147 15.6168 12.843 15.821 13.3359C16.0251 13.8288 16.3244 14.2766 16.7016 14.6539C17.0788 15.0311 17.5267 15.3304 18.0196 15.5345C18.5125 15.7387 19.0407 15.8438 19.5742 15.8438C20.1077 15.8438 20.636 15.7387 21.1289 15.5345C21.6218 15.3304 22.0696 15.0311 22.4468 14.6539C22.8241 14.2766 23.1233 13.8288 23.3275 13.3359C23.5316 12.843 23.6367 12.3147 23.6367 11.7812C23.6367 11.2478 23.5316 10.7195 23.3275 10.2266C23.1233 9.73371 22.8241 9.28587 22.4468 8.90863C22.0696 8.53139 21.6218 8.23215 21.1289 8.02799C20.636 7.82383 20.1077 7.71875 19.5742 7.71875Z"
        fill="#B2CDF2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.96178 20.401C9.75039 20.0744 10.5956 19.9062 11.4492 19.9062C12.3028 19.9062 13.148 20.0744 13.9367 20.401C14.7253 20.7277 15.4418 21.2065 16.0454 21.8101C16.649 22.4136 17.1278 23.1302 17.4544 23.9188C17.7811 24.7074 17.9492 25.5527 17.9492 26.4062C17.9492 27.2598 17.7811 28.1051 17.4544 28.8937C17.1278 29.6823 16.649 30.3989 16.0454 31.0024C15.4418 31.606 14.7253 32.0848 13.9367 32.4115C13.148 32.7381 12.3028 32.9062 11.4492 32.9062C10.5956 32.9062 9.75039 32.7381 8.96178 32.4115C8.17316 32.0848 7.45661 31.606 6.85302 31.0024C6.24944 30.3989 5.77066 29.6823 5.444 28.8937C5.11735 28.1051 4.94922 27.2598 4.94922 26.4062C4.94922 25.5527 5.11735 24.7074 5.444 23.9188C5.77066 23.1302 6.24944 22.4136 6.85302 21.8101C7.45661 21.2065 8.17316 20.7277 8.96178 20.401ZM11.4492 22.3438C10.9157 22.3438 10.3875 22.4488 9.89457 22.653C9.40168 22.8571 8.95384 23.1564 8.5766 23.5336C8.19936 23.9109 7.90012 24.3587 7.69596 24.8516C7.4918 25.3445 7.38672 25.8728 7.38672 26.4062C7.38672 26.9397 7.4918 27.468 7.69596 27.9609C7.90012 28.4538 8.19936 28.9016 8.5766 29.2789C8.95384 29.6561 9.40168 29.9554 9.89457 30.1595C10.3875 30.3637 10.9157 30.4688 11.4492 30.4688C11.9827 30.4688 12.511 30.3637 13.0039 30.1595C13.4968 29.9554 13.9446 29.6561 14.3218 29.2789C14.6991 28.9016 14.9983 28.4538 15.2025 27.9609C15.4066 27.468 15.5117 26.9397 15.5117 26.4062C15.5117 25.8728 15.4066 25.3445 15.2025 24.8516C14.9983 24.3587 14.6991 23.9109 14.3218 23.5336C13.9446 23.1564 13.4968 22.8571 13.0039 22.653C12.511 22.4488 11.9827 22.3438 11.4492 22.3438Z"
        fill="#B2CDF2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.6992 19.9062C26.8456 19.9062 26.0004 20.0744 25.2118 20.401C24.4232 20.7277 23.7066 21.2065 23.103 21.8101C22.4994 22.4136 22.0207 23.1302 21.694 23.9188C21.3673 24.7074 21.1992 25.5527 21.1992 26.4062C21.1992 27.2598 21.3673 28.1051 21.694 28.8937C22.0207 29.6823 22.4994 30.3989 23.103 31.0024C23.7066 31.606 24.4232 32.0848 25.2118 32.4115C26.0004 32.7381 26.8456 32.9062 27.6992 32.9062C28.5528 32.9062 29.398 32.7381 30.1867 32.4115C30.9753 32.0848 31.6918 31.606 32.2954 31.0024C32.899 30.3989 33.3778 29.6823 33.7044 28.8937C34.0311 28.1051 34.1992 27.2598 34.1992 26.4062C34.1992 25.5527 34.0311 24.7074 33.7044 23.9188C33.3778 23.1302 32.899 22.4136 32.2954 21.8101C31.6918 21.2065 30.9753 20.7277 30.1867 20.401C29.398 20.0744 28.5528 19.9062 27.6992 19.9062ZM26.1446 22.653C26.6375 22.4488 27.1657 22.3438 27.6992 22.3438C28.2327 22.3438 28.761 22.4488 29.2539 22.653C29.7468 22.8571 30.1946 23.1564 30.5718 23.5336C30.9491 23.9109 31.2483 24.3587 31.4525 24.8516C31.6566 25.3445 31.7617 25.8728 31.7617 26.4062C31.7617 26.9397 31.6566 27.468 31.4525 27.9609C31.2483 28.4538 30.9491 28.9016 30.5718 29.2789C30.1946 29.6561 29.7468 29.9554 29.2539 30.1595C28.761 30.3637 28.2327 30.4688 27.6992 30.4688C27.1657 30.4688 26.6375 30.3637 26.1446 30.1595C25.6517 29.9554 25.2038 29.6561 24.8266 29.2789C24.4494 28.9016 24.1501 28.4538 23.946 27.9609C23.7418 27.468 23.6367 26.9397 23.6367 26.4062C23.6367 25.8728 23.7418 25.3445 23.946 24.8516C24.1501 24.3587 24.4494 23.9109 24.8266 23.5336C25.2038 23.1564 25.6517 22.8571 26.1446 22.653Z"
        fill="#B2CDF2"
      />
    </g>
  ),
});

export const IconSortArrow = createIcon({
  displayName: "sortArrowIocn",
  viewBox: "0 0 15 17",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="15" width="17" fill="none">
      <path
        d="M10.666 8.09668C10.666 7.82054 10.4422 7.59668 10.166 7.59668C9.88987 7.59668 9.66602 7.82054 9.66602 8.09668L10.666 8.09668ZM9.81246 15.1038C10.0077 15.299 10.3243 15.299 10.5196 15.1038L13.7015 11.9218C13.8968 11.7265 13.8968 11.4099 13.7015 11.2147C13.5063 11.0194 13.1897 11.0194 12.9944 11.2147L10.166 14.0431L7.33759 11.2147C7.14233 11.0194 6.82574 11.0194 6.63048 11.2147C6.43522 11.4099 6.43522 11.7265 6.63048 11.9218L9.81246 15.1038ZM9.66602 8.09668L9.66602 14.7502L10.666 14.7502L10.666 8.09668L9.66602 8.09668Z"
        fill="#8E8C8C"
      />
      <path
        d="M4.2793 9.17773C4.2793 9.45388 4.50315 9.67773 4.7793 9.67773C5.05544 9.67773 5.2793 9.45388 5.2793 9.17773L4.2793 9.17773ZM5.13285 2.17065C4.93759 1.97538 4.62101 1.97538 4.42574 2.17065L1.24376 5.35263C1.0485 5.54789 1.0485 5.86447 1.24376 6.05973C1.43903 6.255 1.75561 6.255 1.95087 6.05973L4.7793 3.23131L7.60772 6.05973C7.80299 6.255 8.11957 6.255 8.31483 6.05973C8.51009 5.86447 8.51009 5.54789 8.31483 5.35263L5.13285 2.17065ZM5.2793 9.17773L5.2793 2.5242L4.2793 2.5242L4.2793 9.17773L5.2793 9.17773Z"
        fill="#DCDCDC"
      />
    </g>
  ),
});

export const IconHeadphone = createIcon({
  displayName: "headPhoneIcon",
  viewBox: "0 0 20 20",
  path: (
    <g xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.70166C6.75862 1.70166 4.24399 3.73168 3.81483 6.20166H6C6.41421 6.20166 6.75 6.53745 6.75 6.95166V13.9517C6.75 14.3659 6.41421 14.7017 6 14.7017H3C1.48122 14.7017 0.25 13.4704 0.25 11.9517V8.95166C0.25 7.68002 1.11311 6.60998 2.28547 6.2954C2.66693 2.79125 6.0738 0.20166 10 0.20166C13.9262 0.20166 17.3331 2.79125 17.7145 6.29541C18.8869 6.60998 19.75 7.68002 19.75 8.95166V11.9517C19.75 13.2269 18.8821 14.2993 17.7047 14.6105C17.3839 16.922 15.3998 18.7017 13 18.7017H11.8546C11.5579 19.4346 10.8393 19.9517 10 19.9517C8.89543 19.9517 8 19.0562 8 17.9517C8 16.8471 8.89543 15.9517 10 15.9517C10.8393 15.9517 11.5579 16.4687 11.8546 17.2017H13C14.5368 17.2017 15.8245 16.135 16.1631 14.7017H14C13.5858 14.7017 13.25 14.3659 13.25 13.9517V6.95166C13.25 6.53745 13.5858 6.20166 14 6.20166H16.1852C15.756 3.73168 13.2414 1.70166 10 1.70166ZM3 7.70166C2.30964 7.70166 1.75 8.2613 1.75 8.95166V11.9517C1.75 12.642 2.30964 13.2017 3 13.2017H5.25V7.70166H3ZM18.25 8.95166C18.25 8.2613 17.6904 7.70166 17 7.70166H14.75V13.2017H17C17.6904 13.2017 18.25 12.642 18.25 11.9517V8.95166Z"
        fill="black"
      />
    </g>
  ),
});
export const IconRemoveFile = createIcon({
  displayName: "removeFileIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19Z"
      fill="black"
    />
  ),
});

export const IconCaretTop = createIcon({
  displayName: "iconCaretTop",
  viewBox: "0 0 1024 256",
  path: (
    <g
      className="svg-icon"
      width="1rem"
      height="1rem"
      viewBox="0 0 1024 256"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M512 0L0 614.4h1024L512 0z" fill="#E9E9E9" />
    </g>
  ),
});

export const IconCaretBottom = createIcon({
  displayName: "iconCaretBottom",
  viewBox: "0 0 1024 256",
  path: (
    <g
      className="svg-icon"
      width="1rem"
      height="1rem"
      viewBox="0 0 1024 256"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0l512 614.4L1024 0H0z" fill="#E9E9E9" />
    </g>
  ),
});

export const IconCheckedSmall = createIcon({
  displayName: "iconCheckedSmall",
  viewBox: "0 0 7 5",
  path: (
    <g
      width="7"
      height="5"
      viewBox="0 0 7 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.43292 0.00683594H5.69741C5.53745 0.00683594 5.38533 0.0836797 5.29123 0.215412L2.82595 3.63419L1.70936 2.08476C1.61526 1.9546 1.46471 1.87618 1.30318 1.87618H0.567675C0.465739 1.87618 0.406146 1.99223 0.465739 2.07535L2.41977 4.78528C2.46594 4.84971 2.52679 4.9022 2.59729 4.93842C2.66779 4.97464 2.74591 4.99353 2.82517 4.99353C2.90443 4.99353 2.98254 4.97464 3.05304 4.93842C3.12354 4.9022 3.1844 4.84971 3.23056 4.78528L6.53329 0.206003C6.59445 0.122886 6.53485 0.00683594 6.43292 0.00683594Z"
        fill="white"
      />
    </g>
  ),
});

export const IconBlueChecked = createIcon({
  displayName: "iconBlueChecked",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="m0 8c0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8z" fill="#3a7bff"/>
      <path d="m13.0883 4.65012c-.0705-.06521-.1545-.11696-.247-.15228-.0924-.03532-.1916-.0535-.2918-.0535s-.1994.01818-.2919.0535-.1765.08707-.247.15228l-5.65446 5.18988-2.37562-2.18448c-.07326-.06486-.15974-.11587-.2545-.1501-.09477-.03423-.19596-.05102-.2978-.0494-.10184.00161-.20234.0216-.29575.05881-.09341.03722-.17792.09094-.24868.15809-.07077.06714-.12642.14641-.16376.23327-.03735.08687-.05566.17962-.0539.27297s.02357.18546.06417.27109c.0406.08562.0992.16308.17246.22794l2.9145 2.67151c.07056.0652.15451.1169.24699.1522.09249.0354.1917.0535.29189.0535.1002 0 .1994-.0181.29189-.0535.09249-.0353.17643-.087.24699-.1522l6.19328-5.67691c.0771-.06514.1386-.14421.1806-.23222.0421-.088.0638-.18304.0638-.27911 0-.09608-.0217-.19112-.0638-.27912-.042-.08801-.1035-.16707-.1806-.23222z" fill="#fff"/>
    </g>
  ),
});

export const IconCheckedCircleGreen = createIcon({
  displayName: "iconCheckedCircleGreen",
  viewBox: "0 0 20 20",
  path: (
    <g
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.625"
        y="0.625"
        width="18.75"
        height="18.75"
        rx="9.375"
        stroke="#00B67A"
        strokeWidth="1.25"
      />
      <path
        d="M15.5917 6.00834C15.5142 5.93023 15.4221 5.86824 15.3205 5.82593C15.219 5.78362 15.11 5.76184 15 5.76184C14.89 5.76184 14.7811 5.78362 14.6796 5.82593C14.578 5.86824 14.4858 5.93023 14.4084 6.00834L8.20004 12.225L5.59171 9.60834C5.51127 9.53064 5.41632 9.46955 5.31227 9.42854C5.20823 9.38754 5.09713 9.36743 4.98531 9.36936C4.87349 9.3713 4.76315 9.39524 4.66058 9.43982C4.55802 9.48439 4.46524 9.54874 4.38754 9.62917C4.30984 9.70961 4.24875 9.80456 4.20774 9.9086C4.16674 10.0126 4.14663 10.1238 4.14856 10.2356C4.1505 10.3474 4.17444 10.4577 4.21902 10.5603C4.2636 10.6629 4.32794 10.7556 4.40837 10.8333L7.60837 14.0333C7.68584 14.1114 7.77801 14.1734 7.87956 14.2157C7.98111 14.2581 8.09003 14.2798 8.20004 14.2798C8.31005 14.2798 8.41897 14.2581 8.52052 14.2157C8.62207 14.1734 8.71424 14.1114 8.79171 14.0333L15.5917 7.23334C15.6763 7.1553 15.7438 7.06059 15.79 6.95518C15.8361 6.84976 15.86 6.73592 15.86 6.62084C15.86 6.50575 15.8361 6.39192 15.79 6.2865C15.7438 6.18108 15.6763 6.08637 15.5917 6.00834V6.00834Z"
        fill="#00B67A"
      />
    </g>
  ),
});

export const IconHamburgur = createIcon({
  displayName: "iconHamBurgur",
  viewBox: "0 0 25 25",
  path: (
    <g
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9863 12.4873C19.9863 12.0731 19.6505 11.7373 19.2363 11.7373H5.23633C4.82211 11.7373 4.48633 12.0731 4.48633 12.4873C4.48633 12.9015 4.82211 13.2373 5.23633 13.2373H19.2363C19.6505 13.2373 19.9863 12.9015 19.9863 12.4873Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9863 7.4873C19.9863 7.07309 19.6505 6.7373 19.2363 6.7373H5.23633C4.82211 6.7373 4.48633 7.07309 4.48633 7.4873C4.48633 7.90152 4.82211 8.2373 5.23633 8.2373H19.2363C19.6505 8.2373 19.9863 7.90152 19.9863 7.4873Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9863 17.4873C19.9863 17.0731 19.6505 16.7373 19.2363 16.7373H5.23633C4.82211 16.7373 4.48633 17.0731 4.48633 17.4873C4.48633 17.9015 4.82211 18.2373 5.23633 18.2373H19.2363C19.6505 18.2373 19.9863 17.9015 19.9863 17.4873Z"
        fill="black"
      />
    </g>
  ),
});

export const IconCloseHamburgur = createIcon({
  displayName: "iconCloseHamburgur",
  viewBox: "0 0 25 25",
  path: (
    <g
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70042 16.0227L15.7715 8.95166"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.70042 8.95188L15.7715 16.0229"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  ),
});

export const IconArrowLongRight = createIcon({
  displayName: "iconArrowLongRight",
  viewBox: "0 0 25 25",
  path: (
    <g
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.206 16.0312C12.9131 16.3241 12.9131 16.799 13.206 17.0919C13.4989 17.3847 13.9738 17.3847 14.2667 17.0919L18.2667 13.0919C18.4131 12.9454 18.4863 12.7535 18.4863 12.5615C18.4863 12.4598 18.4661 12.3629 18.4294 12.2744C18.3928 12.186 18.3386 12.1031 18.2667 12.0312L14.2667 8.03119C13.9738 7.7383 13.4989 7.7383 13.206 8.03119C12.9131 8.32409 12.9131 8.79896 13.206 9.09185L15.9257 11.8115L6.23633 11.8115C5.82211 11.8115 5.48633 12.1473 5.48633 12.5615C5.48633 12.9757 5.82211 13.3115 6.23633 13.3115L15.9257 13.3115L13.206 16.0312Z"
        fill="white"
      />
    </g>
  ),
});

export const IconArrowLongLeft = createIcon({
  displayName: "iconArrowLongLeft",
  viewBox: "0 0 25 25",
  path: (
    <g
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7667 9.09185C12.0596 8.79896 12.0596 8.32409 11.7667 8.03119C11.4738 7.7383 10.9989 7.7383 10.706 8.03119L6.706 12.0312C6.55955 12.1776 6.48633 12.3696 6.48633 12.5615C6.48633 12.6632 6.50657 12.7602 6.54324 12.8486C6.57984 12.9371 6.63409 13.0199 6.706 13.0919L10.706 17.0919C10.9989 17.3847 11.4738 17.3847 11.7667 17.0919C12.0596 16.799 12.0596 16.3241 11.7667 16.0312L9.04699 13.3115L18.7363 13.3115C19.1505 13.3115 19.4863 12.9757 19.4863 12.5615C19.4863 12.1473 19.1505 11.8115 18.7363 11.8115L9.04699 11.8115L11.7667 9.09185Z"
        fill="#2F80ED"
      />
    </g>
  ),
});

export const IconArrowLongBottom = createIcon({
  displayName: "iconArrowLongBottom",
  viewBox: "0 0 25 25",
  path: (
    <g
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.26666 13.0629C8.97377 12.77 8.49889 12.77 8.206 13.0629C7.9131 13.3558 7.9131 13.8307 8.206 14.1236L12.206 18.1236C12.3524 18.27 12.5444 18.3433 12.7363 18.3433C12.838 18.3433 12.935 18.323 13.0234 18.2864C13.1119 18.2498 13.1948 18.1955 13.2667 18.1236L17.2667 14.1236C17.5596 13.8307 17.5596 13.3558 17.2667 13.0629C16.9738 12.77 16.4989 12.77 16.206 13.0629L13.4863 15.7826L13.4863 6.09326C13.4863 5.67905 13.1505 5.34326 12.7363 5.34326C12.3221 5.34326 11.9863 5.67905 11.9863 6.09326L11.9863 15.7826L9.26666 13.0629Z"
        fill="black"
      />
    </g>
  ),
});

// export const IconArrowDown = createIcon({
//   displayName: "iconArrowLongBottom",
//   viewBox: "0 0 25 25",
//   path: (
//     <g
//       width="25"
//       height="25"
//       viewBox="0 0 25 25"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M9.26666 13.0629C8.97377 12.77 8.49889 12.77 8.206 13.0629C7.9131 13.3558 7.9131 13.8307 8.206 14.1236L12.206 18.1236C12.3524 18.27 12.5444 18.3433 12.7363 18.3433C12.838 18.3433 12.935 18.323 13.0234 18.2864C13.1119 18.2498 13.1948 18.1955 13.2667 18.1236L17.2667 14.1236C17.5596 13.8307 17.5596 13.3558 17.2667 13.0629C16.9738 12.77 16.4989 12.77 16.206 13.0629L13.4863 15.7826L13.4863 6.09326C13.4863 5.67905 13.1505 5.34326 12.7363 5.34326C12.3221 5.34326 11.9863 5.67905 11.9863 6.09326L11.9863 15.7826L9.26666 13.0629Z"
//         fill="black"
//       />
//     </g>
//   ),
// });

export const IconCircleInfo = createIcon({
  displayName: "iconArrowLongBottom",
  viewBox: "0 0 18 19",
  path: (
    <g
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 8.20117C9.41421 8.20117 9.75 8.53696 9.75 8.95117V13.9512C9.75 14.3654 9.41421 14.7012 9 14.7012C8.58579 14.7012 8.25 14.3654 8.25 13.9512V8.95117C8.25 8.53696 8.58579 8.20117 9 8.20117Z"
        fill="#CCCCCC"
      />
      <path
        d="M9 6.45117C9.55228 6.45117 10 6.00346 10 5.45117C10 4.89889 9.55228 4.45117 9 4.45117C8.44772 4.45117 8 4.89889 8 5.45117C8 6.00346 8.44772 6.45117 9 6.45117Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 9.45117C0.25 4.61868 4.16751 0.701172 9 0.701172C13.8325 0.701172 17.75 4.61868 17.75 9.45117C17.75 14.2837 13.8325 18.2012 9 18.2012C4.16751 18.2012 0.25 14.2837 0.25 9.45117ZM9 2.20117C4.99594 2.20117 1.75 5.44711 1.75 9.45117C1.75 13.4552 4.99594 16.7012 9 16.7012C13.0041 16.7012 16.25 13.4552 16.25 9.45117C16.25 5.44711 13.0041 2.20117 9 2.20117Z"
        fill="#CCCCCC"
      />
    </g>
  ),
});

export const IconMapPin = createIcon({
  displayName: "mapPinIcon",
  viewBox: "0 0 18 21",
  path: (
    <g
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9999 2.93059C13.4086 1.3393 11.2504 0.445312 8.99993 0.445312C6.74949 0.445313 4.59123 1.3393 2.99993 2.93059C1.40863 4.52189 0.514648 6.68016 0.514648 8.93059C0.514648 11.181 1.40863 13.3393 2.99993 14.9306L8.26993 20.2106C8.36289 20.3043 8.47349 20.3787 8.59535 20.4295C8.71721 20.4803 8.84792 20.5064 8.97993 20.5064C9.11194 20.5064 9.24265 20.4803 9.36451 20.4295C9.48637 20.3787 9.59697 20.3043 9.68993 20.2106L14.9999 14.8806C16.5846 13.2959 17.4748 11.1466 17.4748 8.90559C17.4748 6.66454 16.5846 4.51527 14.9999 2.93059ZM13.5699 13.4506L8.99993 18.0406L4.42993 13.4506C3.52707 12.5469 2.91241 11.3958 2.66362 10.1429C2.41484 8.88993 2.54312 7.59134 3.03223 6.41127C3.52135 5.23121 4.34935 4.22264 5.41156 3.51307C6.47377 2.8035 7.72251 2.42478 8.99993 2.42478C10.2773 2.42478 11.5261 2.8035 12.5883 3.51307C13.6505 4.22264 14.4785 5.23121 14.9676 6.41127C15.4567 7.59134 15.585 8.88993 15.3362 10.1429C15.0875 11.3958 14.4728 12.5469 13.5699 13.4506ZM5.99993 5.86059C5.19264 6.67037 4.73932 7.76716 4.73932 8.91059C4.73932 10.054 5.19264 11.1508 5.99993 11.9606C6.59969 12.5614 7.36352 12.9717 8.19558 13.14C9.02764 13.3083 9.89088 13.2272 10.677 12.9067C11.4631 12.5863 12.1371 12.0409 12.6144 11.3388C13.0917 10.6368 13.3511 9.80947 13.3599 8.96059C13.3644 8.3938 13.2553 7.83185 13.0388 7.30798C12.8224 6.78411 12.5032 6.30895 12.0999 5.91059C11.7036 5.50517 11.231 5.18213 10.7094 4.96006C10.1877 4.73799 9.62727 4.62127 9.06033 4.61662C8.49339 4.61198 7.93113 4.71949 7.4059 4.93298C6.88067 5.14647 6.40285 5.46172 5.99993 5.86059ZM10.6899 10.5406C10.311 10.9253 9.81014 11.1665 9.27306 11.2228C8.73597 11.2792 8.19599 11.1472 7.74544 10.8495C7.29488 10.5518 6.96173 10.1068 6.80294 9.59068C6.64415 9.07452 6.66958 8.51923 6.87489 8.01975C7.0802 7.52027 7.45263 7.10761 7.92851 6.85233C8.4044 6.59705 8.95418 6.515 9.48387 6.62021C10.0135 6.72542 10.4902 7.01135 10.8324 7.42912C11.1746 7.8469 11.3611 8.37056 11.3599 8.91059C11.3454 9.52786 11.0864 10.1141 10.6399 10.5406H10.6899Z"
        fill="black"
      />
    </g>
  ),
});

export const IconUnfollowedUser = createIcon({
  displayName: "unfollowedUserIcon",
  viewBox: "0 0 512 512",
  path: (
    <g>
      <path d="M211.6,0C145.6,0.1,92.2,53.5,92.1,119.5v85c0,15,3.9,29.1,10.7,41.3l-0.2-0.4l29.3,53.7l-77.7,50.5   c-23.5,15.4-38.8,41.6-38.8,71.4v0.2v91H314v-34.1H49.4V421V421c0-17.9,9.2-33.6,23.1-42.7l0.2-0.1l104.2-67.7L132.5,229   c-3.9-7.1-6.2-15.5-6.3-24.5v-85c0-47.1,38.2-85.3,85.3-85.3c47.1,0,85.3,38.2,85.3,85.3v85c0,9-2.3,17.4-6.4,24.8l0.1-0.3   l-44.4,81.4l67.7,44v-40.7L291.3,299l29.3-53.7c6.6-11.8,10.4-25.9,10.4-40.9v-85C331,53.5,277.5,0.1,211.6,0z" />
      <polygon points="496.7,361.9 472.6,337.8 420.6,389.7 368.7,337.8 344.6,361.9 396.5,413.9 344.6,465.8 368.7,489.9 420.6,438    472.6,489.9 496.7,465.8 444.8,413.9  " />
    </g>
  ),
});

export const IconLock = createIcon({
  displayName: "iconLock",
  viewBox: "0 0 28 28",
  path: (
    <path
      d="M19.8334 10.5007V8.16732C19.8334 6.62022 19.2188 5.13649 18.1248 4.04253C17.0308 2.94857 15.5471 2.33398 14 2.33398C12.4529 2.33398 10.9692 2.94857 9.87523 4.04253C8.78127 5.13649 8.16669 6.62022 8.16669 8.16732V10.5007C7.23843 10.5007 6.34819 10.8694 5.69181 11.5258C5.03544 12.1822 4.66669 13.0724 4.66669 14.0007V22.1673C4.66669 23.0956 5.03544 23.9858 5.69181 24.6422C6.34819 25.2986 7.23843 25.6673 8.16669 25.6673H19.8334C20.7616 25.6673 21.6519 25.2986 22.3082 24.6422C22.9646 23.9858 23.3334 23.0956 23.3334 22.1673V14.0007C23.3334 13.0724 22.9646 12.1822 22.3082 11.5258C21.6519 10.8694 20.7616 10.5007 19.8334 10.5007ZM10.5 8.16732C10.5 7.23906 10.8688 6.34882 11.5251 5.69244C12.1815 5.03607 13.0718 4.66732 14 4.66732C14.9283 4.66732 15.8185 5.03607 16.4749 5.69244C17.1313 6.34882 17.5 7.23906 17.5 8.16732V10.5007H10.5V8.16732ZM21 22.1673C21 22.4767 20.8771 22.7735 20.6583 22.9923C20.4395 23.2111 20.1428 23.334 19.8334 23.334H8.16669C7.85727 23.334 7.56052 23.2111 7.34173 22.9923C7.12294 22.7735 7.00002 22.4767 7.00002 22.1673V14.0007C7.00002 13.6912 7.12294 13.3945 7.34173 13.1757C7.56052 12.9569 7.85727 12.834 8.16669 12.834H19.8334C20.1428 12.834 20.4395 12.9569 20.6583 13.1757C20.8771 13.3945 21 13.6912 21 14.0007V22.1673Z"
      fill="#00B67A"
    />
  ),
});

export const IconDeliveryDate = createIcon({
  displayName: "iconDeliveryDate",
  viewBox: "0 0 14 15",
  path: (
    <path
      d="M7.00003 12.1754C7.12763 12.1754 7.25236 12.1376 7.35846 12.0667C7.46456 11.9958 7.54725 11.895 7.59608 11.7772C7.64491 11.6593 7.65769 11.5295 7.63279 11.4044C7.6079 11.2792 7.54645 11.1643 7.45622 11.0741C7.366 10.9838 7.25104 10.9224 7.12589 10.8975C7.00074 10.8726 6.87102 10.8854 6.75313 10.9342C6.63524 10.983 6.53448 11.0657 6.46359 11.1718C6.3927 11.2779 6.35486 11.4027 6.35486 11.5303C6.35486 11.7014 6.42284 11.8655 6.54383 11.9865C6.66482 12.1075 6.82892 12.1754 7.00003 12.1754ZM10.2258 12.1754C10.3534 12.1754 10.4782 12.1376 10.5843 12.0667C10.6904 11.9958 10.7731 11.895 10.8219 11.7772C10.8707 11.6593 10.8835 11.5295 10.8586 11.4044C10.8337 11.2792 10.7723 11.1643 10.682 11.0741C10.5918 10.9838 10.4769 10.9224 10.3517 10.8975C10.2266 10.8726 10.0968 10.8854 9.97895 10.9342C9.86106 10.983 9.7603 11.0657 9.68941 11.1718C9.61851 11.2779 9.58068 11.4027 9.58068 11.5303C9.58068 11.7014 9.64865 11.8655 9.76964 11.9865C9.89063 12.1075 10.0547 12.1754 10.2258 12.1754ZM10.2258 9.59478C10.3534 9.59478 10.4782 9.55694 10.5843 9.48605C10.6904 9.41516 10.7731 9.31439 10.8219 9.19651C10.8707 9.07862 10.8835 8.9489 10.8586 8.82375C10.8337 8.6986 10.7723 8.58364 10.682 8.49341C10.5918 8.40319 10.4769 8.34174 10.3517 8.31685C10.2266 8.29195 10.0968 8.30473 9.97895 8.35356C9.86106 8.40239 9.7603 8.48508 9.68941 8.59118C9.61851 8.69728 9.58068 8.82201 9.58068 8.94961C9.58068 9.12072 9.64865 9.28482 9.76964 9.40581C9.89063 9.5268 10.0547 9.59478 10.2258 9.59478ZM7.00003 9.59478C7.12763 9.59478 7.25236 9.55694 7.35846 9.48605C7.46456 9.41516 7.54725 9.31439 7.59608 9.19651C7.64491 9.07862 7.65769 8.9489 7.63279 8.82375C7.6079 8.6986 7.54645 8.58364 7.45622 8.49341C7.366 8.40319 7.25104 8.34174 7.12589 8.31685C7.00074 8.29195 6.87102 8.30473 6.75313 8.35356C6.63524 8.40239 6.53448 8.48508 6.46359 8.59118C6.3927 8.69728 6.35486 8.82201 6.35486 8.94961C6.35486 9.12072 6.42284 9.28482 6.54383 9.40581C6.66482 9.5268 6.82892 9.59478 7.00003 9.59478ZM11.5162 1.85283H10.871V1.20766C10.871 1.03655 10.803 0.872455 10.682 0.751464C10.561 0.630472 10.3969 0.5625 10.2258 0.5625C10.0547 0.5625 9.89063 0.630472 9.76964 0.751464C9.64865 0.872455 9.58068 1.03655 9.58068 1.20766V1.85283H4.41938V1.20766C4.41938 1.03655 4.3514 0.872455 4.23041 0.751464C4.10942 0.630472 3.94532 0.5625 3.77421 0.5625C3.60311 0.5625 3.43901 0.630472 3.31801 0.751464C3.19702 0.872455 3.12905 1.03655 3.12905 1.20766V1.85283H2.48389C1.97057 1.85283 1.47827 2.05674 1.11529 2.41972C0.752318 2.78269 0.548401 3.27499 0.548401 3.78831V12.8206C0.548401 13.3339 0.752318 13.8262 1.11529 14.1892C1.47827 14.5522 1.97057 14.7561 2.48389 14.7561H11.5162C12.0295 14.7561 12.5218 14.5522 12.8848 14.1892C13.2477 13.8262 13.4517 13.3339 13.4517 12.8206V3.78831C13.4517 3.27499 13.2477 2.78269 12.8848 2.41972C12.5218 2.05674 12.0295 1.85283 11.5162 1.85283ZM12.1613 12.8206C12.1613 12.9917 12.0934 13.1558 11.9724 13.2768C11.8514 13.3978 11.6873 13.4658 11.5162 13.4658H2.48389C2.31278 13.4658 2.14868 13.3978 2.02769 13.2768C1.9067 13.1558 1.83873 12.9917 1.83873 12.8206V7.01413H12.1613V12.8206ZM12.1613 5.7238H1.83873V3.78831C1.83873 3.61721 1.9067 3.45311 2.02769 3.33211C2.14868 3.21112 2.31278 3.14315 2.48389 3.14315H3.12905V3.78831C3.12905 3.95942 3.19702 4.12352 3.31801 4.24451C3.43901 4.3655 3.60311 4.43348 3.77421 4.43348C3.94532 4.43348 4.10942 4.3655 4.23041 4.24451C4.3514 4.12352 4.41938 3.95942 4.41938 3.78831V3.14315H9.58068V3.78831C9.58068 3.95942 9.64865 4.12352 9.76964 4.24451C9.89063 4.3655 10.0547 4.43348 10.2258 4.43348C10.3969 4.43348 10.561 4.3655 10.682 4.24451C10.803 4.12352 10.871 3.95942 10.871 3.78831V3.14315H11.5162C11.6873 3.14315 11.8514 3.21112 11.9724 3.33211C12.0934 3.45311 12.1613 3.61721 12.1613 3.78831V5.7238ZM3.77421 9.59478C3.90181 9.59478 4.02655 9.55694 4.13265 9.48605C4.23874 9.41516 4.32144 9.31439 4.37027 9.19651C4.4191 9.07862 4.43187 8.9489 4.40698 8.82375C4.38209 8.6986 4.32064 8.58364 4.23041 8.49341C4.14018 8.40319 4.02523 8.34174 3.90008 8.31685C3.77493 8.29195 3.64521 8.30473 3.52732 8.35356C3.40943 8.40239 3.30867 8.48508 3.23778 8.59118C3.16689 8.69728 3.12905 8.82201 3.12905 8.94961C3.12905 9.12072 3.19702 9.28482 3.31801 9.40581C3.43901 9.5268 3.60311 9.59478 3.77421 9.59478ZM3.77421 12.1754C3.90181 12.1754 4.02655 12.1376 4.13265 12.0667C4.23874 11.9958 4.32144 11.895 4.37027 11.7772C4.4191 11.6593 4.43187 11.5295 4.40698 11.4044C4.38209 11.2792 4.32064 11.1643 4.23041 11.0741C4.14018 10.9838 4.02523 10.9224 3.90008 10.8975C3.77493 10.8726 3.64521 10.8854 3.52732 10.9342C3.40943 10.983 3.30867 11.0657 3.23778 11.1718C3.16689 11.2779 3.12905 11.4027 3.12905 11.5303C3.12905 11.7014 3.19702 11.8655 3.31801 11.9865C3.43901 12.1075 3.60311 12.1754 3.77421 12.1754Z"
      fill="#666666"
    />
  ),
});

export const IconPostOrderSupport = createIcon({
  displayName: "iconPostOrderSupport",
  viewBox: "0 0 16 17",
  path: (
    <path
      d="M11.3333 5.32552H4.66665C4.48984 5.32552 4.32027 5.39576 4.19524 5.52078C4.07022 5.64581 3.99998 5.81538 3.99998 5.99219C3.99998 6.169 4.07022 6.33857 4.19524 6.46359C4.32027 6.58862 4.48984 6.65885 4.66665 6.65885H11.3333C11.5101 6.65885 11.6797 6.58862 11.8047 6.46359C11.9297 6.33857 12 6.169 12 5.99219C12 5.81538 11.9297 5.64581 11.8047 5.52078C11.6797 5.39576 11.5101 5.32552 11.3333 5.32552ZM11.3333 7.99219H4.66665C4.48984 7.99219 4.32027 8.06243 4.19524 8.18745C4.07022 8.31247 3.99998 8.48204 3.99998 8.65885C3.99998 8.83567 4.07022 9.00523 4.19524 9.13026C4.32027 9.25528 4.48984 9.32552 4.66665 9.32552H11.3333C11.5101 9.32552 11.6797 9.25528 11.8047 9.13026C11.9297 9.00523 12 8.83567 12 8.65885C12 8.48204 11.9297 8.31247 11.8047 8.18745C11.6797 8.06243 11.5101 7.99219 11.3333 7.99219ZM12.6666 1.99219H3.33331C2.80288 1.99219 2.29417 2.2029 1.9191 2.57797C1.54403 2.95305 1.33331 3.46175 1.33331 3.99219V10.6589C1.33331 11.1893 1.54403 11.698 1.9191 12.0731C2.29417 12.4481 2.80288 12.6589 3.33331 12.6589H11.06L13.5266 15.1322C13.5889 15.194 13.6628 15.2429 13.744 15.276C13.8253 15.3092 13.9122 15.326 14 15.3255C14.0874 15.3278 14.1742 15.3095 14.2533 15.2722C14.3751 15.2222 14.4793 15.1372 14.5528 15.0281C14.6264 14.9189 14.666 14.7905 14.6666 14.6589V3.99219C14.6666 3.46175 14.4559 2.95305 14.0809 2.57797C13.7058 2.2029 13.1971 1.99219 12.6666 1.99219ZM13.3333 13.0522L11.8066 11.5189C11.7444 11.4571 11.6705 11.4082 11.5893 11.375C11.508 11.3418 11.4211 11.325 11.3333 11.3255H3.33331C3.1565 11.3255 2.98693 11.2553 2.86191 11.1303C2.73688 11.0052 2.66665 10.8357 2.66665 10.6589V3.99219C2.66665 3.81538 2.73688 3.64581 2.86191 3.52078C2.98693 3.39576 3.1565 3.32552 3.33331 3.32552H12.6666C12.8435 3.32552 13.013 3.39576 13.1381 3.52078C13.2631 3.64581 13.3333 3.81538 13.3333 3.99219V13.0522Z"
      fill="#666666"
    />
  ),
});

export const IconCart = createIcon({
  displayName: "iconCart",
  viewBox: "0 0 16 17",
  path: (
    <svg fill="none">
      <path
        d="M0.5 1H3.5V10H13.5L15.5 3H6.5"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16C4.82843 16 5.5 15.3284 5.5 14.5C5.5 13.6716 4.82843 13 4 13C3.17157 13 2.5 13.6716 2.5 14.5C2.5 15.3284 3.17157 16 4 16Z"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 16C13.8284 16 14.5 15.3284 14.5 14.5C14.5 13.6716 13.8284 13 13 13C12.1716 13 11.5 13.6716 11.5 14.5C11.5 15.3284 12.1716 16 13 16Z"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const IconMobileCaretDown = createIcon({
  displayName: "iconMobileCaretDown",
  viewBox: "0 0 16 17",
  path: (
    <path
      fill="none"
      d="M3.5 7L8 11.5L12.5 7"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
